import React, { useState, useEffect, useCallback, useRef } from "react";
import {
  IoCheckmarkOutline,
  IoCloseOutline,
  IoCloudUploadOutline,
} from "react-icons/io5";
import dayjs from "dayjs";
import verify from "../../assets/images/verify.png";
import authActions from "../../redux/auth/actions";
import imageCompression from "browser-image-compression";
import { useSelector, useDispatch } from "react-redux";
import candidatesActions from "../../redux/candidates/actions";
import masterActions from "../../redux/master/action";
import SubmitButton from "../../common/submitButton";
import SaveButton from "../../common/saveButton";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { PiTruckTrailerDuotone, PiX } from "react-icons/pi";
import pdf from "../../assets/images/uploads/pdf.png";
import jpeg from "../../assets/images/uploads/jpeg.png";
import word from "../../assets/images/uploads/docs.png";
import png from "../../assets/images/uploads/png.jpg";
import { CircularProgress, Backdrop } from "@mui/material";
import ImageCrop from "./imageCrop";
import ImageCropSignature from "./imageCropSignature";
import BackButton from "../../common/backButton";
import axios from "axios";
import { IoClose } from "react-icons/io5";
import { CiWarning } from "react-icons/ci";
import { HiBadgeCheck } from "react-icons/hi";
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  useMediaQuery,
  useTheme,
  TextField,
  Modal,
  Tooltip,
  Paper
} from "@mui/material";
import { LuImagePlus } from "react-icons/lu";
import { MdCameraAlt } from "react-icons/md";
import Webcam from "react-webcam";
import * as faceapi from '@vladmandic/face-api';
import Cookies from "js-cookie";
import { LuCheck, LuPencilLine } from "react-icons/lu";
import { BiSolidUser } from "react-icons/bi";
import signature from "../../../src/assets/images/sidebar/signature 1.png";
import userphoto from "../../../src/assets/images/example.png";
import sign from "../../../src/assets/images/sign.png";
import ReactCrop, { convertToPixelCrop } from "react-image-crop";
import { FiEye, FiEyeOff } from "react-icons/fi";

import { GrAttachment, GrTextWrap } from "react-icons/gr";
import commonActions from "../../redux/common/actions";
import { DecryptObjectFunction, EncryptFunction, EncryptObjectFunction } from "../../utils/cryptoFunction";
import { BsCardImage } from "react-icons/bs";
import CameraDenied from "../../assets/images/cameraDenied.png";
import { styled } from '@mui/material/styles';
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);

const StyledLabel = styled(InputLabel)(({ theme }) => ({
  color: 'black',
  marginTop: '-5px',
  '&.MuiInputLabel-shrink': {
    marginTop: '0px',
  },
}));
export default function UploadsForm({ editingFormData, editingFacilityAmount, updateDetailsClicked }) {
  const [photofilename, setPhotoImage] = useState("");
  const [loading, setLoading] = useState(false);
  const [disbaleBtnwhenCloserToTheEdge, setDisableBtnwhenCloserToTheEdge] = useState(false)
  const [photoSize, setPhotoSize] = useState("");
  const [photoSizeCompressed, setPhotoSizeCompressed] = useState("");
  const [signfilename, setSignatureImage] = useState("");
  const [signatureSize, setSignatureSize] = useState("");
  const [signatureSizeCompressed, setSignatureSizeCompressed] = useState("");
  const [size, setSize] = useState("");
  const [photoError, setError] = useState("");
  const [signatureError, setSignatureError] = useState("");
  const [documentTypeError, setDocumentTypeError] = useState("");
  const [documentError, setDocumentError] = useState("");
  const [photoCheckError, setPhotoCheckError] = useState("");
  const [signatureCheckError, setSignatureCheckError] = useState("");
  const [documentid, setDocumentId] = useState("");
  const [photoURL, setPhotoURL] = useState("");
  const [signURL, setSignURL] = useState("");
  const [docURL, setDocURL] = useState("");
  const [udidURL, setUdidURL] = useState("");
  const [annexureURL, setAnnexureURL] = useState("");
  const [enableCrop, setEnableCrop] = useState(false)
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const fileInputRef = useRef(null);
  const fileInputRefSignature = useRef(null);
  const [open, setOpen] = useState(false);
  const [signatureOpen, setSignatureOpen] = useState(false);
  //  const [afterSave, setAfterSave] = useState(false);
  const location = useLocation();
  const isEditingPage = location.pathname.includes("editing-facility");
  const courseId = location?.state?.courseId;
  const courseName = sessionStorage.getItem("coursename") ? sessionStorage.getItem("coursename") : location?.state?.courseName;
  // console.log(fromUrl,fromPreviewPage, "lkjhgfdftgyuhijkhgfcd")
  const [filetype, setFiletype] = useState();
  // prashanth
  const [captureOpen, setcaptureOpen] = useState(false);
  const [uploadValue, setUploadValue] = useState()
  const [signatureValue, setSignatureValue] = useState()
  const [afterSave, setAfterSave] = useState(false);
  const webcamRef = useRef(null);
  const [showWebcam, setShowWebcam] = useState(false);
  const [cameraPermissionModal, setCameraPermissionModal] = useState(false);
  const [mode, setMode] = useState("");
  const [borderColor, setBorderColor] = useState("transparent");
  const detectionIntervalRef = useRef(null);
  const [pwdDocument, setPwdDocument] = useState({
    udiddocument: null,
    annexuredocument: null
  });
  const [pwdDocumentError, setPwdDocumentError] = useState({
    udiddocument: "",
    annexuredocument: ""
  });

  const gcpUrl = process.env.REACT_APP_ANNEXURE1_URL
  // prashanth

  const fromPreview = location?.state?.fromPreview;
  const courseid = location.state?.courseid;
  const coursename = location.state?.coursename;

  const doctyperef = useRef(null);
  const docref = useRef(null);
  const canvasRef = useRef(null);
  const [searchParams] = useSearchParams();
  const encryptedParams = searchParams.get("c_data");
  let decrypted = encryptedParams ? DecryptObjectFunction(encryptedParams) : null;
  const editStatus = decrypted?.status;
  const courseidValue = decrypted?.courseid;
  const coursenameValue = decrypted?.coursename;
  const [showCard, setShowCard] = useState(null);
  const [signatureShowCard, setSignatureShowCard] = useState(null);
  const [captureshowCard, setCaptureShowCard] = useState(null);
  const [firstErrorlist, setFirstErrorList] = useState("")
  const [secondErrorlist, setSecondErrorList] = useState("")
  const [thirdErrorlist, setThirdErrorList] = useState("")
  const [forthErrorlist, setForthErrorList] = useState("")
  const [fifthErrorlist, setFifthErrorList] = useState("")
  const [confirmationList, setConfirmationList] = useState("")
  const [modelsLoaded, setModelsLoaded] = useState(false);

  const sleep = (ms) => new Promise(res => setTimeout(res, ms));

  let modelLoadPromise = null;

  const ensureModelsLoaded = () => {
    if (!modelLoadPromise) {
      modelLoadPromise = (async () => {
        // console.log('Starting model load...');
        // console.log('Loading face-api models...');
        // await sleep(3000);
        await faceapi.nets.tinyFaceDetector.loadFromUri('https://storage.googleapis.com/mhcet-reg-prod-2-public-bucket/models');
        await faceapi.nets.faceLandmark68Net.loadFromUri('https://storage.googleapis.com/mhcet-reg-prod-2-public-bucket/models');
        // await faceapi.nets.faceRecognitionNet.loadFromUri('/models')
        // console.log('Face-api models loaded');
        return true;
      })();
    }
    return modelLoadPromise;
  };



  //   const loadModels = async () => {
  //   await faceapi.nets.tinyFaceDetector.loadFromUri('/models');
  //   await faceapi.nets.faceLandmark68Net.loadFromUri('/models');
  // };


  // useEffect(() => {
  //   if (showWebcam) {

  //     // const loadModels = async () => {
  //     //   await faceapi.nets.tinyFaceDetector.loadFromUri('/models');
  //     //   await faceapi.nets.faceLandmark68Net.loadFromUri('/models');
  //     // };



  //     // loadModels();
  //   }
  // }, [showWebcam]);



  const handleIconClick = () => {
    setOpen(true);
  };
  const handleCaptureIconClick = async () => {
    try {
      setMode("capture")
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });
      stream.getTracks().forEach(track => track.stop());
      setShowWebcam(true);
    } catch (err) {
      console.warn("Camera permission denied:", err);
      setCameraPermissionModal(true);
    }
    setcaptureOpen(true);
  }



  useEffect(() => {
    let intervalId;



    const runDetection = async () => {
      const video = webcamRef.current?.video;
      const canvas = canvasRef.current;
      if (!video || !canvas) return;

      const videoWidth = video.videoWidth;
      const videoHeight = video.videoHeight;

      canvas.width = videoWidth;
      canvas.height = videoHeight;

      await ensureModelsLoaded();

      const detections = await faceapi
        .detectAllFaces(video, new faceapi.TinyFaceDetectorOptions())
        .withFaceLandmarks();
        // console.log("face detection started")

      const ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      // Draw rectangle size
      const boxWidth = videoWidth * 0.6;
      const boxHeight = videoHeight * 0.8;
      const boxX = (videoWidth - boxWidth) / 2;
      const boxY = (videoHeight - boxHeight) / 2;

      // Default border color is RED
      let boxColor = "red";

      // Clear previous messages
      setFirstErrorList("");
      setSecondErrorList("");
      setThirdErrorList("");
      setForthErrorList("");
      setFifthErrorList("")
      setConfirmationList("");

      if (detections.length === 0) {
        return;
        // setFirstErrorList("No face detected");
      } else if (detections.length > 1) {
        setSecondErrorList("Multiple faces detected.");
      } else {
        const detection = detections[0];
        const { x, y, width, height } = detection.detection.box;
        const faceCenterX = x + width / 2;
        const faceCenterY = y + height / 2;

        const videoCenterX = videoWidth / 2;
        const videoCenterY = videoHeight / 2;
        const toleranceX = videoWidth * 0.3;
        const toleranceY = videoHeight * 0.3;

        const isCentered =
          Math.abs(faceCenterX - videoCenterX) < toleranceX &&
          Math.abs(faceCenterY - videoCenterY) < toleranceY;

        if (!isCentered) {

          const offsetX = faceCenterX - videoCenterX;
          const offsetY = faceCenterY - videoCenterY;
          const moveThreshold = 100;
          const dx = Math.round(Math.abs(offsetX));
          const dy = Math.round(Math.abs(offsetY));


          let message = "";

          if (offsetX < -moveThreshold) {
            message = `Move your face → right by ~${dx}px.`;
          } else if (offsetX > moveThreshold) {
            message = `Move your face ← left by ~${dx}px.`;
          } else if (offsetY < -moveThreshold) {
            message = `Move your face ↓ down by ~${dy}px.`;
          } else if (offsetY > moveThreshold) {
            message = `Move your face ↑ up by ~${dy}px.`;
          } else {
            message = "Align your face exactly inside the green box.";
          }
          setThirdErrorList(message);
        } else {
          // Optional: white background check
          const hiddenCanvas = document.createElement("canvas");
          hiddenCanvas.width = videoWidth;
          hiddenCanvas.height = videoHeight;
          const hiddenCtx = hiddenCanvas.getContext("2d");
          hiddenCtx.drawImage(video, 0, 0, videoWidth, videoHeight);

          const sampleWhitePixel = (x, y) => {
            const [r, g, b] = hiddenCtx.getImageData(x, y, 1, 1).data;
            return r > 200 && g > 200 && b > 200;
          };

          const boxWidth = videoWidth * 0.6;
          const boxHeight = videoHeight * 0.8;
          const boxX = (videoWidth - boxWidth) / 2;
          const boxY = (videoHeight - boxHeight) / 2;

          const detection = detections[0];
          const { x, y, width, height } = detection.detection.box;

          const padding = 25;

          const hairAllowance = 80;
          const faceLeft = x;
          const faceRight = x + width;
          const faceTop = y - hairAllowance < 0 ? 0 : y - hairAllowance;
          const faceBottom = y + height;

          const tooCloseToEdge =
            faceLeft < boxX + padding ||
            faceRight > boxX + boxWidth - padding ||
            faceTop < boxY + padding ||
            faceBottom > boxY + boxHeight - padding;

          if (tooCloseToEdge) {
            setThirdErrorList("Move your face slightly toward the center — too close to the edge.");
            setDisableBtnwhenCloserToTheEdge(true)
            boxColor = "red";
          } else {
            setConfirmationList("Proceed to capture");
            boxColor = "green";
            setDisableBtnwhenCloserToTheEdge(false)
          }
        }
      }

      // ✅ Finally draw the border based on status
      ctx.beginPath();
      ctx.rect(boxX, boxY, boxWidth, boxHeight);
      ctx.strokeStyle = boxColor;
      ctx.lineWidth = 3;
      ctx.stroke();
    };

    if (captureOpen && !open) {
      intervalId = setInterval(() => {
        runDetection();
      }, 1000);
    }

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
        setFirstErrorList("");
        setSecondErrorList("");
        setThirdErrorList("");
        setForthErrorList("");
        setFifthErrorList("")
        setConfirmationList("");
      }
    };
  }, [captureOpen, open]);


  const handleNextClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = null; // Reset kare bina same file select nahi hoga
      fileInputRef.current.click();
    }
    setMode("upload")
    // fileInputRef.current.click();
  };


  const handleIconClickSignature = () => {
    setSignatureOpen(true);
  };

  const handleNextSignatureClick = () => {
    if (fileInputRefSignature.current) {
      fileInputRefSignature.current.value = null;
      fileInputRefSignature.current.click();

    }


  };

  const handleDialogClose = () => {
    setOpen(false);
    setcaptureOpen(false);
    setSignatureOpen(false);
  };

  const [documentName, setDocumentName] = useState("");
  const [documentfilename, setDocument] = useState("");
  const [showModal, setShowModal] = useState({ show: false, data: null });
  const [showModalSignature, setShowModalSignature] = useState({
    show: false,
    data: null,
  });

  const [confirmPhotoImage, setConfirmPhotoImage] = useState(true);
  const [confirmSignatureImage, setConfirmSignatureImage] = useState(true);

  const [cropPhotoImage, setCropPhotoImage] = useState(null);
  const [cropSignatureImage, setCropSignatureImage] = useState(null);

  // // const { candidateTokenDetails } = useSelector((state) => state.authReducer);
  // const candidateid = candidateTokenDetails?.candidateid;
  const ProfileSummaryDetails = useSelector(
    (state) => state.authReducer.ProfileSummaryDetails
  );
  const otherDetails = useSelector(
    (state) => state.candidatesReducer.otherDetails
  );

  const isPwdAllowed = ![7, 24]?.includes(parseInt(otherDetails[0]?.subdisabilitytypeid))


  const {
    candidateid,
    candidatename,
    mobilenoverified,
    profiledetailstatus,
    addressdetailstatus,
    otherdetailstatus,
    uploaddetailstatus,
  } = ProfileSummaryDetails?.[0] || {};

  // const {isdisability} = otherDetails?.[0] || null;
  const isdisability = otherDetails?.[0]?.isdisability ?? null;


  useEffect(() => {
    if (candidateid) {
      dispatch({ type: candidatesActions.GET_UPLOAD_PERSONAL_DETAILS });
    }

  }, [candidateid])

  useEffect(() => {
    if (candidateid) {
      dispatch({ type: candidatesActions.GET_OTHER_PERSONAL_DETAILS, payload: candidateid });
    }
  }, [candidateid])

  const { uploadDetails,
    courseUploadDetails,
    candidateNameForEditing,
     candidateDobForEditing,
     candidateGenderForEditing,
     candidateGroupForEditing,
     pcm_noofattemptsediting,
     pcb_noofattemptsediting,
     noofattemptsediting,
      gelctediting,
     englishmediumediting,
     } = useSelector((state) => state.candidatesReducer);
  const { documentType } = useSelector((state) => state.masterReducer);
  // const doc = uploadDetails
  //   ? uploadDetails?.find((item, index) => item?.documenttype == 3)?.filename
  //   : "document name";

  // const match = doc?.match(/\.(jpeg|jpg|pdf)$/);
  // const extension = match ? match[1] : null;

  // const fileType2 = extension;
  const docTypes = [3, 4, 5];
  const getFileExtensionByDocType = (uploadDetails, docType) => {
    const doc = uploadDetails?.find(item => item?.documenttype === docType)?.filename;
    if (!doc) return null;

    const match = doc.match(/\.(jpeg|jpg|pdf)$/i);
    return match ? match[1].toLowerCase() : null;
  };

  const fileTypes = docTypes.reduce((acc, type) => {
    acc[type] = getFileExtensionByDocType(uploadDetails, type);
    return acc;
  }, {});


  const candidateuploaddraftid = uploadDetails[0]?.candidateuploaddraftid
    ? uploadDetails[0]?.candidateuploaddraftid
    : uploadDetails[1]?.candidateuploaddraftid
      ? uploadDetails[1]?.candidateuploaddraftid
      : uploadDetails[2]?.candidateuploaddraftid;
  const candidateuploadid = uploadDetails[0]?.candidateuploadid
    ? uploadDetails[0]?.candidateuploadid
    : uploadDetails[1]?.candidateuploadid
      ? uploadDetails[1]?.candidateuploadid
      : uploadDetails[2]?.candidateuploadid;

  useEffect(() => {
    let timer;
    // if(uploadDetails.length<=0){

    dispatch({ type: masterActions.GET_DOCUMENT_TYPE });
    // }
    return () => {
      if (timer) clearTimeout(timer); // Cleanup the timeout
    };
  }, [candidateid]);

  useEffect(() => {
    if (isEditingPage) {
      dispatch({
        type: candidatesActions.GET_COURSE_UPLOAD_PERSONAL_DETAILS,
        data: {
          courseid: courseId || sessionStorage.getItem("courseid"),
        },
      });
    }
  }, [isEditingPage])

  useEffect(() => {
    if (uploadDetails?.length > 0) {
      setDocumentId(uploadDetails[0]?.documentid || "");
      const photoUrl = uploadDetails?.find(
        (item, index) => item?.documenttype == 1 && item?.fileurl
      )?.fileurl;
      const signUrl = uploadDetails?.find(
        (item, index) => item?.documenttype == 2 && item?.fileurl
      )?.fileurl;
      const docUrl = uploadDetails?.find(
        (item, index) => item?.documenttype == 3 && item?.fileurl
      )?.fileurl;
      const udidUrl = uploadDetails?.find(
        (item, index) => item?.documenttype == 4 && item?.fileurl
      )?.fileurl;
      const annexureUrl = uploadDetails?.find(
        (item, index) => item?.documenttype == 5 && item?.fileurl
      )?.fileurl;

      setPhotoURL(photoUrl);
      setSignURL(signUrl);
      setDocURL(docUrl);
      setUdidURL(udidUrl);
      setAnnexureURL(annexureUrl)
    }
    if (courseUploadDetails.length > 0 && isEditingPage) {
      const photoUrl = courseUploadDetails?.find(
        (item, index) => item?.documenttype == 1 && item?.fileurl
      )?.fileurl;
      const signUrl = courseUploadDetails?.find(
        (item, index) => item?.documenttype == 2 && item?.fileurl
      )?.fileurl;
      setPhotoURL(photoUrl);
      setSignURL(signUrl);

    }
  }, [uploadDetails, courseUploadDetails]);

  const handleDocumentUpload = (event) => {
    const file = event.target.files[0];

    const docSize = file?.size;

    if (docSize <= 2097152) {
      const fileName = file.name;

      const fileType = fileName.split(".").pop().toLowerCase();
      // if (fileType === 'docx') {
      //   setFiletype('docx')
      // }
      if (fileType === "pdf") {
        setFiletype("pdf");
      } else if (fileType === "jpeg") {
        setFiletype("jpeg");
      } else if (fileType === "jpg") {
        setFiletype("jpeg");
      }
      // else if (fileType === 'png') {
      //   setFiletype('png')
      // }
      else {
        setDocumentError(
          "Document Type Not Supported. Please upload JPG/PDF format only"
        );
        return;
      }

      setDocumentName(fileName);
      setDocument(file);
      setDocumentError("");

      event.target.value = null;
    } else {
      setDocumentName("");
      setDocument("");
      setDocumentError("You cannot upload file larger than 2MB");

      event.target.value = null;
    }
  };

  const handlePwdDocumentUpload = (event) => {
    const file = event.target.files[0];
    const fieldName = event.target.name;
    const docSize = file?.size;

    if (!file) return;

    if (docSize > 2097152) {
      setPwdDocumentError((prev) => ({
        ...prev,
        [fieldName]: "You cannot upload a file larger than 2MB"
      }));

      setPwdDocument((prev) => ({
        ...prev,
        [fieldName]: null
      }));

      event.target.value = null;
      return;
    }

    const fileName = file.name;
    const fileType = fileName.split(".").pop().toLowerCase();

    if (!["pdf", "jpeg", "jpg"].includes(fileType)) {
      setPwdDocumentError((prev) => ({
        ...prev,
        [fieldName]: "Document Type Not Supported. Allowed: PDF, JPG, JPEG"
      }));

      setPwdDocument((prev) => ({
        ...prev,
        [fieldName]: null
      }));

      event.target.value = null;
      return;
    }


    setPwdDocument((prev) => ({
      ...prev,
      [fieldName]: file
    }));

    setPwdDocumentError((prev) => ({
      ...prev,
      [fieldName]: ""
    }));

    event.target.value = null;
  };



  const handleDocumentDrop = (event) => {
    event.preventDefault();
    const file = event.dataTransfer.files[0];
    if (file) {
      setDocumentName(file.name);
      setDocument(file);
      setDocumentError("");
      event.target.value = null;
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleCloseDocument = () => {
    setDocumentName("");
  };

  const handleDocumentId = (event) => {
    setDocumentId(event.target.value);
    setDocumentTypeError("");
  };

  const handleClose = () => {
    setShowModal({ show: false, data: null });
    setcaptureOpen(false);
    setOpen(false)
    setSignatureOpen(false);

  };

  const { buttonLoader } = useSelector((state) => state.commonReducer);
  const { draftButtonLoader, showPaymentConfirmationModal } = useSelector((state) => state.commonReducer);

  const {
    showImage,
    showCompressedImage,
    showSignature,
    showCompressedSignature,
  } = useSelector((state) => state.candidatesReducer);

  // console.log(showImage,
  //   showCompressedImage,
  //   showSignature,
  //   showCompressedSignature,'pks')

  // const handleImageUpload = async (event) => {
  //   const file = event.target.files[0];
  //   if (!file) return;

  //   const fileSizeInKB = file.size / 1024;
  //   setPhotoSize(fileSizeInKB.toFixed(2));
  //   setSize(fileSizeInKB);

  //   // Assuming that the modal should open regardless of file size
  //   setShowModal({ show: true, data: null });
  //   if (fileSizeInKB > 300) {
  //     try {
  //       const options = {
  //         maxSizeMB: 0.1,
  //         maxWidthOrHeight: 800,
  //         useWebWorker: true,
  //       };
  //       const compressedFile = await imageCompression(file, options);
  //       const unCompressedFile = URL.createObjectURL(file);
  //       const convertedFileCompressed = URL.createObjectURL(compressedFile);

  //       setConfirmPhotoImage("");
  //       setCropPhotoImage(convertedFileCompressed);

  //       setConfirmPhotoImage(false);
  //       setSize("");
  //       setPhotoImage("");
  //       setPhotoImage(compressedFile);
  //       setPhotoSizeCompressed("");
  //       setPhotoSizeCompressed(compressedFile);
  //     } catch (err) {
  //     }

  //     // Reset the file input field
  //     event.target.value = null;
  //   } else {

  //     try {
  //       const options = {
  //         maxSizeMB: 0.1,
  //         maxWidthOrHeight: 800,
  //         useWebWorker: true,
  //       };
  //       const compressedFile = await imageCompression(file, options);
  //       const unCompressedFile = URL.createObjectURL(file);
  //       const convertedFileCompressed = URL.createObjectURL(compressedFile);

  //       setConfirmPhotoImage("");
  //       setCropPhotoImage(unCompressedFile);

  //       setConfirmPhotoImage(false);
  //       setSize("");
  //       setPhotoImage("");
  //       setPhotoImage(file);
  //       setPhotoSizeCompressed("");
  //       setPhotoSizeCompressed(file);
  //     } catch (err) {
  //     }

  //     // Reset the file input field
  //     event.target.value = null;

  //   }

  // };

  const handleImageShow = async (e) => {
    const file = e.target.files[0];
    setUploadValue(file);
    if (!file) return;
    const formData = new FormData();
    formData.append("file", file);
    setLoading(true)
    try {

      const response = await axios.post(
        `${process.env.REACT_APP_AI_BASE_URL}/face-detect`,
        formData,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response.data.detected == false) {
        setForthErrorList(response?.data?.details ? response?.data?.details : "Human Face Not Detected");
        setConfirmationList("");
      } else {
        setConfirmationList(response?.data?.details ? response?.data?.details : "Face detected");
        setForthErrorList("");
      }
    } catch (error) {
      setForthErrorList("Try Again...")
      setConfirmationList("")
    }




    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setShowCard(reader.result); // Show new image
      };
      reader.readAsDataURL(file);
    }
    setLoading(false)
  }
  const handleSignatureShow = async (e) => {
    const file = e.target.files[0];


    if (!file) return;
    const formData = new FormData();
    formData.append("file", file);
    setForthErrorList("");
    setConfirmationList("");
    setLoading(true)
    try {
      const response = await axios.post(
        // "https://mh-cet-facesign.hubblehox.ai/sign-detect",
        `${process.env.REACT_APP_AI_BASE_URL}/sign-detect`,
        formData,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response.data.detected == false) {
        setForthErrorList(response?.data?.details ? response?.data?.details : "Signature Not Detected");
        setConfirmationList("");

      } else {
        setConfirmationList(response?.data?.details ? response?.data?.details : "Signature detected.");
        setForthErrorList("");

      }
    } catch (error) {
      setForthErrorList("Try again...");
      setConfirmationList("");
    }
    const reader = new FileReader();
    reader.onloadend = () => {
      setSignatureShowCard(reader.result); // Show new image
    };
    reader.readAsDataURL(file);
    setSignatureValue(file)
    setLoading(false)

  }
  const handleImageCaptureShow = async () => {
    setConfirmationList("")
    const imageSrc = webcamRef.current.getScreenshot();
    setCaptureShowCard(imageSrc);

    if (!imageSrc) return;
    setLoading(true)
    try {
      // Convert base64 to blob
      const blob = await fetch(imageSrc).then(res => res.blob());
      const file = new File([blob], "camera-photo.jpg", { type: "image/jpeg" });

      const formData = new FormData();
      formData.append("file", file);

      // 🔍 FACE DETECTION API
      const response = await axios.post(
        `${process.env.REACT_APP_AI_BASE_URL}/face-detect`,
        formData,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data.detected == false) {
        setForthErrorList(response?.data?.details ? response?.data?.details : "Human Face Not Detected")
        setFifthErrorList("Please try capturing your face again, or upload a photo to proceed with verification")
        setConfirmationList("");
      } else {
        setConfirmationList(response?.data?.details ? response?.data?.details : "Face detected")
        setForthErrorList("")
        setFifthErrorList("")
      }
    } catch (error) {
      setForthErrorList("Try Again...")
      setFifthErrorList("Please try capturing your face again, or upload a photo to proceed with verification")
      setConfirmationList("");
    }
    setLoading(false)
  }

  const handleCaptureSave = async () => {
    let imageSrc = captureshowCard;
    const blob = await fetch(imageSrc).then(res => res.blob());
    const file = new File([blob], "camera-photo.jpg", { type: "image/jpeg" });
    handleCaptureImageUpload({ target: { files: [file] } });
  }

  const handleImageUpload = async () => {
    const file = uploadValue;
    const fileSizeInKB = file.size / 1024;
    setPhotoSize(fileSizeInKB.toFixed(2));
    setSize(fileSizeInKB);

    // Open the modal before processing the image
    setShowModal({ show: true, data: null });

    try {
      let finalFile = file; // Default to the original file
      let compressedFileUrl = URL.createObjectURL(file); // Use original file URL initially

      const maxAllowedSizeKB = 4096; // 4 MB
      const compressThresholdKB = 5120;

      console.log("Original size KB:", file.size / 1024);


      if (fileSizeInKB > compressThresholdKB) {
        let quality = 0.9; // Start with high quality
        let compressedBlob = file;
        while ((compressedBlob.size / 1024) > maxAllowedSizeKB && quality > 0.1) {
          const options = {
            maxSizeMB: maxAllowedSizeKB / 1024, // 4 MB in MB
            maxWidthOrHeight: 5120, // Adjust resolution if needed
            useWebWorker: true,
            initialQuality: quality,
          };

          compressedBlob = await imageCompression(file, options);
          quality -= 0.05;
        }
        finalFile = compressedBlob;
        compressedFileUrl = URL.createObjectURL(finalFile);
      }

      console.log(finalFile,"final file size")

      // Reset previous state before setting new values
      setConfirmPhotoImage(null);
      setCropPhotoImage(compressedFileUrl);
      setPhotoImage(finalFile);
      setPhotoSizeCompressed(
        fileSizeInKB > compressThresholdKB ? finalFile.size / 1024 : fileSizeInKB
      );
      setSize(null);
    } catch (err) {
      console.error("Image compression error:", err);
    }
    setAfterSave(true)
    setUploadValue("");
  };
  const handleCaptureImageUpload = async (event) => {

    const file = event.target.files[0];
    // if (!file) return;
    // const formData = new FormData();
    // formData.append("file", file);

    // try {
    //   const response = await axios.post(
    //     "https://mh-cet-facesign.hubblehox.ai/face-detect",
    //     formData,
    //     {
    //       headers: {
    //         Accept: "application/json",
    //         "Content-Type": "multipart/form-data",
    //       },
    //     }
    //   );
    //   if (response.data.detected == false) {
    //     dispatch({
    //       type: commonActions.SET_ALERT,
    //       payload: {
    //         status: "failed",
    //         show: true,
    //         message: "Please upload a correct image",
    //       },
    //     });
    //     setTimeout(() => {
    //       dispatch({
    //         type: commonActions.SET_ALERT,
    //         payload: { show: false },
    //       });
    //     }, 2000);
    //     return;
    //   } else {
    //     dispatch({
    //       type: commonActions.SET_ALERT,
    //       payload: {
    //         status: "success",
    //         show: true,
    //         message: "Face validated successfully",
    //       },
    //     });
    //     setTimeout(() => {
    //       dispatch({
    //         type: commonActions.SET_ALERT,
    //         payload: { show: false },
    //       });
    //     }, 1000);
    //   }
    // } catch (error) {
    //   console.error("Upload failed:", error);
    // }

    const fileSizeInKB = file.size / 1024;
    setPhotoSize(fileSizeInKB.toFixed(2));
    setSize(fileSizeInKB);

    // Open the modal before processing the image
    setShowModal({ show: true, data: null });

    try {
      let finalFile = file; // Default to the original file
      let compressedFileUrl = URL.createObjectURL(file); // Use original file URL initially

      const maxAllowedSizeKB = 4096; // 4 MB
      const compressThresholdKB = 5120;

      if (fileSizeInKB > compressThresholdKB) {
        let quality = 0.9; // Start with high quality
        let compressedBlob = file;
        while ((compressedBlob.size / 1024) > maxAllowedSizeKB && quality > 0.1) {
          const options = {
            maxSizeMB: maxAllowedSizeKB / 1024, // 4 MB in MB
            maxWidthOrHeight: 5120, // Adjust resolution if needed
            useWebWorker: true,
            initialQuality: quality,
          };

          compressedBlob = await imageCompression(file, options);
          quality -= 0.05;
        }
        finalFile = compressedBlob;
        compressedFileUrl = URL.createObjectURL(finalFile);
      }

      // Reset previous state before setting new values
      setConfirmPhotoImage(null);
      setCropPhotoImage(compressedFileUrl);
      setPhotoImage(finalFile);
      setPhotoSizeCompressed(
        fileSizeInKB > compressThresholdKB ? finalFile.size / 1024 : fileSizeInKB
      );
      setSize(null);
    } catch (err) {
      console.error("Image compression error:", err);
    }

    // Reset file input field

    event.target.value = null;
  };
  const handleSignatureUpload = async () => {
    const file = signatureValue;
    if (!file) return;
    const fileSizeInKB = file.size / 1024;
    setSize(fileSizeInKB);
    setSignatureSize(fileSizeInKB.toFixed(2));
    // if (fileSizeInKB > 300) {
    setShowModalSignature({ show: true, data: null });
    try {
      let finalFile = file;
      let compressedFileUrl = URL.createObjectURL(file);

      const maxAllowedSizeKB = 1945; // ~1.9 MB target (in KB)
      const compressThresholdKB = 2048; // compress only if >2 MB
      if (fileSizeInKB > compressThresholdKB) {
        let quality = 0.9; // start with high quality
        let compressedBlob = file;

        // Iteratively compress until under ~1.9MB or quality becomes very low
        while ((compressedBlob.size / 1024) > maxAllowedSizeKB && quality > 0.1) {
          const options = {
            maxSizeMB: maxAllowedSizeKB / 1024, // ~1.9 MB in MB
            maxWidthOrHeight: 2000, // adjust dimensions if needed
            useWebWorker: true,
            initialQuality: quality,
          };
          compressedBlob = await imageCompression(file, options);
          quality -= 0.1;
        }

        finalFile = compressedBlob;
        compressedFileUrl = URL.createObjectURL(finalFile);
      }

      setCropSignatureImage(compressedFileUrl);
      // setSignatureSizeCompressed(finalFile);
      // setConfirmSignatureImage(false);
      // setSignatureImage(finalFile);
    } catch (err) { }

    setSignatureValue("");
  };

  function base64ToFile(base64String, fileName) {
    if (!base64String) {
      return null;
    }
    const byteString = atob(base64String.split(",")[1]);
    const mimeString = base64String.split(",")[0].split(":")[1].split(";")[0];
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);

    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    return new File([ab], fileName, { type: mimeString });
  }
  useEffect(() => {
    // When switching between capture and upload modes, reset all validation messages
    setFirstErrorList("");
    setSecondErrorList("");
    setThirdErrorList("");
    setForthErrorList("");
    setFifthErrorList("")
    if (uploadValue && !afterSave) {

      setConfirmationList("");

    }

    return () => {

      setAfterSave(false)

    }
    // setCropPhotoImage(null)
  }, [captureOpen, open, uploadValue]);


  // const handleSubmit = () => {

  //   const operation = candidateuploadid ? 1 : 0;

  //   const base64DocumentImage = uploadDetails[0]?.document;
  //   const base64DocumentSignature = uploadDetails[1]?.document;
  //   const base64DocumentDocument = uploadDetails[2]?.document;
  //   const currentSignature = base64ToFile(
  //     base64DocumentSignature,
  //     `${candidateid}_signature.jpeg`
  //   );
  //   const currentImage = base64ToFile(
  //     base64DocumentImage,
  //     `${candidateid}_photo.jpeg`
  //   );
  //   const currentDocument = base64ToFile(
  //     base64DocumentDocument,
  //     `${uploadDetails[2]?.filename}`
  //   );

  //   if (
  //     (photofilename || uploadDetails[0]?.document || cropPhotoImage || photoURL) &&
  //     (signfilename || uploadDetails[1]?.document || cropSignatureImage || signURL) &&
  //     (documentfilename || uploadDetails[2]?.document || docURL) &&
  //     (documentid || uploadDetails[0]?.documentid)
  //     // &&
  //     // (cropPhotoImage ? confirmPhotoImage : uploadDetails[0]?.filename) &&
  //     // (cropSignatureImage ? confirmSignatureImage : uploadDetails[1]?.filename)
  //   ) {
  //     const data = {
  //       photofilename: photofilename ? photofilename : null,
  //       signfilename: signfilename ? signfilename : null,
  //       documentfilename: documentfilename ? documentfilename : null,
  //       photoUrl: photoURL ? photoURL : null,
  //       signUrl: signURL ? signURL : null,
  //       docUrl: docURL ? docURL : null,
  //       courseid: courseid,
  //       coursename: coursename,
  //       fromPreview: fromPreview,
  //       filetype: filetype
  //     };

  //     dispatch({
  //       type: candidatesActions.PROFILE_UPLOADS_DETAILS_CREATION,
  //       payload: {
  //         data: {
  //           ...data,
  //           operation: operation,
  //           candidateid: candidateid,
  //           documentid: documentid ? documentid : uploadDetails[0].documentid,
  //           status: 2,
  //           photoname: uploadDetails ? uploadDetails[0]?.filename : null,
  //           signname: uploadDetails ? uploadDetails[1]?.filename : null,
  //           docname: uploadDetails ? uploadDetails[2]?.filename : null
  //         },
  //         navigate: navigate,
  //         editStatus: editStatus,
  //         courseid: courseidValue,
  //         coursename: coursenameValue
  //       },
  //     });

  //     dispatch({ type: candidatesActions.GET_UPLOAD_PERSONAL_DETAILS });

  //   } else {
  //     if (!cropPhotoImage && !uploadDetails[0]?.filename) {
  //       setError("Image is mandatory");
  //       fileInputRef?.current?.focus()
  //     }
  //     if (!cropSignatureImage && !uploadDetails[1]?.filename) {
  //       setSignatureError("Signature is mandatory");
  //       fileInputRefSignature?.current?.focus()

  //     }
  //     if (documentid && !documentfilename && !uploadDetails[2]?.filename) {
  //       setDocumentError("Document is mandatory");
  //       doctyperef?.current?.focus()

  //     }
  //     if (!documentid) {
  //       setDocumentTypeError("Select one document type");
  //       docref?.current?.focus()

  //     }

  //   }

  // };

  const handleSubmit = () => {
    const operation = candidateuploadid ? 1 : 0;
    const base64DocumentImage = uploadDetails[0]?.document;
    const base64DocumentSignature = uploadDetails[1]?.document;
    const base64DocumentDocument = uploadDetails[2]?.document;

    const currentSignature = base64ToFile(
      base64DocumentSignature,
      `${candidateid}_signature.jpeg`
    );
    const currentImage = base64ToFile(
      base64DocumentImage,
      `${candidateid}_photo.jpeg`
    );
    const currentDocument = base64ToFile(
      base64DocumentDocument,
      `${uploadDetails[2]?.filename}`
    );

    // Clear any previous error
    setError(null);
    setSignatureError(null);
    setDocumentError(null);
    setDocumentTypeError(null);
    setPwdDocumentError({
      udiddocument: null,
      annexuredocument: null
    })

    let hasError = false; // Track if there are any errors

    // Validate photo input
    if (
      !(
        photofilename ||
        uploadDetails[0]?.document ||
        cropPhotoImage ||
        photoURL
      )
    ) {
      setError("Please upload or capture your photo");
      if (fileInputRef?.current)
        fileInputRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        }); // Scroll to photo input
      hasError = true;
    }

        if (
      (photofilename?.size) > 2 * 1024 * 1024
    ) {
      dispatch({
        type: commonActions.SET_ALERT,
        payload: {
          status: "failed",
          show: true,
          message: "Photo size too big. Kindly upload file size less than 2 MB and proceed.",
        }
      });
      setTimeout(() => {
        dispatch({
          type: commonActions.SET_ALERT,
          payload: {
            status: null,
            show: false,
            message: null,
          },
        });
      }, 6000);
      return;
    }

    if (
      (photofilename?.size || uploadDetails?.[0]?.document?.size || cropPhotoImage?.size) < 15 * 1024
    ) {
      dispatch({
        type: commonActions.SET_ALERT,
        payload: {
          status: "failed",
          show: true,
          message: "Photo size too small. Kindly upload file size greater than 15kb and proceed.",
        }
      });
      setTimeout(() => {
        dispatch({
          type: commonActions.SET_ALERT,
          payload: {
            status: null,
            show: false,
            message: null,
          },
        });
      }, 6000);
      return;
    }


    // Validate signature input
    if (
      !(
        signfilename ||
        uploadDetails[1]?.document ||
        cropSignatureImage ||
        signURL
      )
    ) {
      setSignatureError("Signature is mandatory");
      if (fileInputRefSignature?.current)
        fileInputRefSignature.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        }); // Scroll to signature input
      hasError = true;
    }


      if (
      (signfilename?.size > 2 * 1024 * 1024)
    ) {
      dispatch({
        type: commonActions.SET_ALERT,
        payload: {
          status: "failed",
          show: true,
          message: "Sign size too big. Kindly upload file size less than 2 MB and proceed.",
        }
      });
      setTimeout(() => {
        dispatch({
          type: commonActions.SET_ALERT,
          payload: {
            status: null,
            show: false,
            message: null,
          },
        });
      }, 6000);
      return;
    }

    
        if (
      (signfilename?.size || uploadDetails?.[1]?.document?.size || cropSignatureImage?.size) < 5 * 1024
    ) {
      dispatch({
        type: commonActions.SET_ALERT,
        payload: {
          status: "failed",
          show: true,
          message: "Sign size too small. Kindly upload file size greater than 5kb and proceed.",
        }
      });
      setTimeout(() => {
        dispatch({
          type: commonActions.SET_ALERT,
          payload: {
            status: null,
            show: false,
            message: null,
          },
        });
      }, 6000);
      return;
    }


    // Validate document input
    if (
      documentid &&
      !(documentfilename || uploadDetails[2]?.document || docURL)
    ) {
      setDocumentError("Document is mandatory");
      if (doctyperef?.current)
        doctyperef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        }); // Scroll to document input
      hasError = true;
    }

    // Validate document type
    if (!documentid) {
      setDocumentTypeError("Select one document type");
      if (docref?.current)
        docref.current.scrollIntoView({ behavior: "smooth", block: "center" }); // Scroll to document type input
      hasError = true;
    }


    if (isdisability === "1" && !(pwdDocument.udiddocument || uploadDetails[3]?.fileUrl || udidURL)) {
      setPwdDocumentError(prev => ({
        ...prev,
        udiddocument: "Please upload UDID / Disability Certificate",
      }));

      if (docref?.current) {
        docref.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }

      hasError = true;
    }

    const isValidFile = (value) =>
  value !== null &&
  value !== undefined &&
  value !== "" &&
  value !== "null";

    const envHasCourseId =
  process.env.REACT_APP_HIDE_LAST_APPENDIX_DOC
    ?.split(",")
    ?.map(id => id.trim())
    ?.includes(courseid || sessionStorage.getItem("courseid"));

const isScribeRequired =
  isdisability === "1" &&
  otherDetails[0]?.isscriberequired === "1" &&
  isPwdAllowed;

const hasAnnexure =
  isValidFile(pwdDocument?.annexuredocument) ||
  isValidFile(uploadDetails?.[4]?.fileUrl) ||
  isValidFile(annexureURL);

const hasNoAnnexure = !hasAnnexure;

    

if (isScribeRequired && hasNoAnnexure && !envHasCourseId) {
      setPwdDocumentError(prev => ({
        ...prev,
        annexuredocument: "Please upload Appendix 1 / Medical Certificate document",
      }));

      if (docref?.current) {
        docref.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }

      hasError = true;
    }


    // return;

    // If there's any error, stop further execution
    if (hasError) {
      return; // Stop form submission and prevent dispatching actions
    }

    // If no errors, prepare the data for submission
    const data = {
      photofilename: photofilename ? photofilename : null,
      signfilename: signfilename ? signfilename : null,
      documentfilename: documentfilename ? documentfilename : null,
      photoUrl: photoURL ? photoURL : null,
      signUrl: signURL ? signURL : null,
      docUrl: docURL ? docURL : null,
      courseid: courseid || sessionStorage.getItem("courseid"),
      coursename: coursename || sessionStorage.getItem("coursename"),
      fromPreview: fromPreview,
      filetype: filetype,
      isdisability
    };




    // Dispatch action
    // console.log(fromPreviewPage,fromUrl,'pks')
    dispatch({
      type: candidatesActions.PROFILE_UPLOADS_DETAILS_CREATION,
      payload: {
        data: {
          ...data,
          udiddocument: pwdDocument.udiddocument ? pwdDocument.udiddocument : null,
          annexurefilename: pwdDocument.annexuredocument ? pwdDocument.annexuredocument : null,
          udidUrl: udidURL ? udidURL : null,
          annexureUrl: annexureURL && isPwdAllowed && otherDetails[0]?.isscriberequired === "1" ? annexureURL : null,
          operation: operation,
          candidateid: candidateid,
          documentid: documentid ? documentid : uploadDetails[0].documentid,
          status: 2,
          photoname: uploadDetails ? uploadDetails[0]?.filename : null,
          signname: uploadDetails ? uploadDetails[1]?.filename : null,
          docname: uploadDetails ? uploadDetails[2]?.filename : null,
        },
        navigate: navigate,
        editStatus: editStatus,
        courseid: courseidValue || sessionStorage.getItem("courseid"),
        coursename: coursenameValue || sessionStorage.getItem("coursename"),
        courseId: courseId,
        courseName: courseName,
        previewFlag: sessionStorage.getItem("preview")

      },
    });

    // Call another dispatch to get the uploaded personal details
    // dispatch({ type: candidatesActions.GET_UPLOAD_PERSONAL_DETAILS });
  };

  // const handleOpenPaymentConfirmationModal = () => {
  //   if(showPaymentConfirmationModal){
  //     return (
  //       <>

  //       </>
  //     )
  //   }
  // }

  const handleEditingFacilityFunc = () => {



    const data = {
      photofilename: photofilename ? photofilename : null,
      signfilename: signfilename ? signfilename : null,
      photoUrl: photoURL ? photoURL : null,
      signUrl: signURL ? signURL : null,
      courseid: courseid || sessionStorage.getItem("courseid"),
      coursename: coursename || sessionStorage.getItem("coursename"),
      filetype: filetype,
    };
    
    const formattedDOB = dayjs(candidateDobForEditing, "DD/MM/YYYY").format("YYYY-MM-DD");

    dispatch({
      type: candidatesActions.EDIT_COURSE_DETAILS,
      payload: {
        data: {
          ...data,
          candidatename: candidateNameForEditing,
          dob: formattedDOB,
          genderid: candidateGenderForEditing,
          subjectgroup: (courseid == 124 || sessionStorage.getItem("courseid") == 124) ? candidateGroupForEditing : null,
          pcm_noofattempts: (courseid == 124 || sessionStorage.getItem("courseid") == 124) ? pcm_noofattemptsediting : null,
          pcb_noofattempts: (courseid == 124 || sessionStorage.getItem("courseid") == 124) ? pcb_noofattemptsediting : null,
          noofattempts: (courseid == 125 || sessionStorage.getItem("courseid") == 125) ? noofattemptsediting : null,
          gengmediumcollege: (courseid == 132 || sessionStorage.getItem("courseid") == 132) ? (englishmediumediting.toString()) : null,
          geltc: (courseid == 132 || sessionStorage.getItem("courseid") == 132) ? Number(gelctediting) : null,
          courseid: courseid || sessionStorage.getItem("courseid"),
          candidateid: candidateid,
          datalog: JSON.stringify(editingFormData),
          // photourl: photofilename ? photofilename : courseUploadDetails?.find((item) => item?.documenttype == 1)
          //       ?.fileurl ||
          //     uploadDetails?.find((item) => item?.documenttype == 1)?.fileurl,
          // signurl: signfilename ? signfilename : courseUploadDetails?.find((item) => item?.documenttype == 2)
          //       ?.fileurl ||
          //     uploadDetails?.find((item) => item?.documenttype == 2)?.fileurl,
        },
        navigate: navigate,
        edit: true,
        // isExtraFee: isExtraFee,
        // coursename: courseName,
        // subjectgroup: editingFormData?.subjectgroup,
        // photofilename: photofilename || "",
        // signfilename: signfilename || "",
      },
    });
  }


  const handleDraft = () => {
    const operation = candidateuploaddraftid ? 1 : 0;
    const base64DocumentImage = uploadDetails[0]?.document
      ? uploadDetails[0]?.document
      : null;
    const base64DocumentSignature = uploadDetails[1]?.document
      ? uploadDetails[1]?.document
      : null;
    const base64DocumentDocument = uploadDetails[2]?.document
      ? uploadDetails[2]?.document
      : null;

    const data = {
      photofilename: photofilename ? photofilename : null,
      signfilename: signfilename ? signfilename : null,
      documentfilename: documentfilename ? documentfilename : null,
      photoUrl: photoURL ? photoURL : null,
      signUrl: signURL ? signURL : null,
      docUrl: docURL ? docURL : null,
      filetype: filetype,
    };


    // if((uploadDetails.length>=1 || photofilename?.name !== null || photofilename?.name !== undefined || photofilename?.name !== "" || photofilename?.name !== NaN) || signfilename || documentfilename){
    //   dispatch({
    //   type: candidatesActions.PROFILE_UPLOADS_DETAILS_DRAFT_CREATION,
    //   payload: {
    //     data: {
    //       ...data,
    //       operation: parseInt(operation),
    //       candidateid: parseInt(candidateid),
    //       documentid: documentid
    //         ? documentid
    //         : uploadDetails[0]?.documentid
    //         ? uploadDetails[0]?.documentid
    //         : null,
    //       status: 1,
    //     },
    //     courseId:courseId,
    //     courseName:courseName,
    //     previewFlag : sessionStorage.getItem("preview")
    //   },
    // });
    // } 
    let hasUploadedAny = false;
    if (
      photofilename || uploadDetails[0]?.document || cropPhotoImage || photoURL ||
      signfilename || uploadDetails[1]?.document || cropSignatureImage || signURL ||
      (documentid && (documentfilename || uploadDetails[2]?.document || docURL)) ||
      (isdisability === "1" && (pwdDocument.udiddocument || uploadDetails[3]?.document || docURL))
    ) {
      hasUploadedAny = true;
    }

    if (!hasUploadedAny) {
      dispatch({
        type: commonActions.SET_ALERT,
        payload: {
          status: "failed",
          show: true,
          message: "Please upload any one of the document to proceed.",
        }
      });
      setTimeout(() => {
        dispatch({
          type: commonActions.SET_ALERT,
          payload: {
            status: null,
            show: false,
            message: null,
          },
        });
      }, 2000);

      if (fileInputRef?.current) {
        fileInputRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }

      return;
    } else {
      dispatch({
        type: candidatesActions.PROFILE_UPLOADS_DETAILS_DRAFT_CREATION,
        payload: {
          data: {
            ...data,
            udiddocument: pwdDocument.udiddocument ? pwdDocument.udiddocument : null,
            annexurefilename: pwdDocument.annexuredocument ? pwdDocument.annexuredocument : null,
            udidUrl: udidURL ? udidURL : null,
            annexureUrl: annexureURL && isPwdAllowed && otherDetails[0]?.isscriberequired === "1" ? annexureURL : null,
            operation: parseInt(operation),
            candidateid: parseInt(candidateid),
            documentid: documentid
              ? documentid
              : uploadDetails[0]?.documentid
                ? uploadDetails[0]?.documentid
                : null,
            status: 1,
          },
          courseId: courseId,
          courseName: courseName,
          previewFlag: sessionStorage.getItem("preview")
        },
      });
    }
    // else {
    //   // alert("Please upload any one of the document to proceed.")
    //   dispatch({
    //     type: commonActions.SET_ALERT,
    //     payload: {
    //       status: "failed",
    //       show: true,
    //       message: "Please upload any one of the document to proceed.",
    //     }
    //   });
    //   setTimeout(() => {
    //     dispatch({
    //       type: commonActions.SET_ALERT,
    //       payload: {
    //         status: null,
    //         show: false,
    //         message: null,
    //       },
    //     });
    //   }, 2000);
    // }
    //  dispatch({ type: candidatesActions.GET_UPLOAD_PERSONAL_DETAILS });
  };

  const onCropDone = (dataURL, crop) => {

    if (!dataURL || !crop) return;

    // Convert base64 to binary data for creating a file
    const byteString = atob(dataURL.split(",")[1]);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const uint8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      uint8Array[i] = byteString.charCodeAt(i);
    }

    // Create a Blob and File from the binary data
    const blob = new Blob([uint8Array], { type: "image/jpeg" });
    const file = new File([blob], "croppedImage.jpg", { type: "image/jpeg" });

    // Set up the file for further use or uploading
    const dataTransfer = new DataTransfer();

    dataTransfer.items.add(file);

    // Create a hidden file input to hold the cropped file
    const fileInput = document.createElement("input");
    fileInput.type = "file";
    fileInput.files = dataTransfer.files;
    setPhotoImage(fileInput.files[0]);

    console.log(fileInput.files[0],"fileinputconsoledddd")

    // Dispatch the cropped image URL and any other necessary actions
    dispatch({
      type: candidatesActions.SHOW_IMAGE,
      payload: dataURL,
    });
    dispatch({
      type: candidatesActions.SHOW_COMPRESSED_IMAGE,
      payload: dataURL,
    });

    // Close the modal and reset crop state
    setShowModal({ show: false, data: null });
    setcaptureOpen(false)
    setOpen(false)
    setCaptureShowCard(null)
    setShowCard(null)
  };

  useEffect(() => {
    if(showImage){
    const byteString = atob(showImage.split(",")[1]);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const uint8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      uint8Array[i] = byteString.charCodeAt(i);
    }

    // Create a Blob and File from the binary data
    const blob = new Blob([uint8Array], { type: "image/jpeg" });
    const file = new File([blob], "croppedImage.jpg", { type: "image/jpeg" });

    // Set up the file for further use or uploading
    const dataTransfer = new DataTransfer();

    dataTransfer.items.add(file);

    // Create a hidden file input to hold the cropped file
    const fileInput = document.createElement("input");
    fileInput.type = "file";
    fileInput.files = dataTransfer.files;
    // setPhotoImage(fileInput.files[0]);
    }
  },[showImage]);


    useEffect(() => {
    if(showSignature){
    const byteString = atob(showSignature.split(",")[1]);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const uint8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      uint8Array[i] = byteString.charCodeAt(i);
    }

    // Create a Blob and File from the binary data
    const blob = new Blob([uint8Array], { type: "image/jpeg" });
    const file = new File([blob], "croppedImage.jpg", { type: "image/jpeg" });

    // Set up the file for further use or uploading
    const dataTransfer = new DataTransfer();

    dataTransfer.items.add(file);

    // Create a hidden file input to hold the cropped file
    const fileInput = document.createElement("input");
    fileInput.type = "file";
    fileInput.files = dataTransfer.files;
    // setSignatureImage(fileInput.files[0]);
    }
  },[showSignature]);







  const onCropDoneSignature = (dataURL, crop) => {
    if (!dataURL || !crop) return;

    // Convert base64 to binary data for creating a file
    const byteString = atob(dataURL.split(",")[1]);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const uint8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      uint8Array[i] = byteString.charCodeAt(i);
    }

    // Create a Blob and File from the binary data
    const blob = new Blob([uint8Array], { type: "image/jpeg" });
    const file = new File([blob], "croppedImage.jpg", { type: "image/jpeg" });

    // Set up the file for further use or uploading
    const dataTransfer = new DataTransfer();

    dataTransfer.items.add(file);

    // Create a hidden file input to hold the cropped file
    const fileInput = document.createElement("input");
    fileInput.type = "file";
    fileInput.files = dataTransfer.files;
    setSignatureImage(fileInput.files[0]);
    setSignatureSizeCompressed(fileInput.files[0]);

    console.log(fileInput.files[0], "signature file size")

    // Dispatch the cropped image URL and any other necessary actions
    dispatch({
      type: candidatesActions.SHOW_SIGNATURE,
      payload: dataURL,
    });
    dispatch({
      type: candidatesActions.SHOW_COMPRESSED_SIGNATURE,
      payload: dataURL,
    });
    setShowModalSignature({ show: false, data: null });
    setSignatureOpen(false);
  };

  const onCropCancelSignature = () => {
    setShowModalSignature({ show: false, data: null });
    dispatch({
      type: candidatesActions.SHOW_SIGNATURE,
      payload: null,
    });
    dispatch({
      type: candidatesActions.SHOW_COMPRESSED_SIGNATURE,
      payload: null,
    });
    setSignatureImage("");
    setSignatureSize("");
    setSignatureSizeCompressed("");
    setSignatureValue("");
    setSignatureShowCard(null);
    setSignatureOpen(false);
    setCropSignatureImage(null);
  };
  const onCropCancel = () => {
    if (captureOpen) {
      setPhotoImage("");
      setUploadValue("");
      setCaptureShowCard(null);
    }
    setShowWebcam(false);
    setShowModal({ show: false, data: null });
    dispatch({
      type: candidatesActions.SHOW_IMAGE,
      payload: null,
    });
    dispatch({
      type: candidatesActions.SHOW_COMPRESSED_IMAGE,
      payload: null,
    });
    setOpen(false);
    setcaptureOpen(false);
    setEnableCrop(false)
    setCropPhotoImage(null)
  };
  const onCaptureCropCancel = () => {
    setShowWebcam(true);

    setShowModal({ show: false, data: null });

    dispatch({
      type: candidatesActions.SHOW_IMAGE,
      payload: null
    })
    dispatch({
      type: candidatesActions.SHOW_COMPRESSED_IMAGE,
      payload: null
    })
    setOpen(false);
    setcaptureOpen(false);
  };

  const handleBack = () => {
    sessionStorage.removeItem("draftclicked");
    // navigate(
    //   `/${sessionStorage.getItem("mhet_cnd_project")}/registration?page=otherdetails`
    // );

    dispatch({
      type: candidatesActions.SHOW_IMAGE,
      payload: null,
    });
    dispatch({
      type: candidatesActions.SHOW_SIGNATURE,
      payload: null,
    });

    // setPhotoImage("");
    // setPhotoSize("");
    // setSignatureImage("");
    // setSignatureSize("");
    // // window.location.reload();
    if (isEditingPage) {
      dispatch({
        type: commonActions.SET_UPDATE_DETAILS, payload: false
      })
      return
    }

    navigate(-1);
  };

  useEffect(() => {
    if (uploadDetails.length > 0) {
      if (candidateid) {
        dispatch({
          type: commonActions.SHOW_SIDEBAR,
          payload:
            uploadDetails?.length == 0
              ? false
              : uploadDetails[0]?.candidateuploaddraftid
                ? false
                : true,
        });
      }
    }
  }, [uploadDetails]);

  // prashanth
  // const handleCameraClick = async () => {

  //   try {
  //     const stream = await navigator.mediaDevices.getUserMedia({ video: true });
  //     stream.getTracks().forEach(track => track.stop());
  //     setShowWebcam(true);
  //   } catch (err) {
  //     console.warn("Camera permission denied:", err);
  //     setCameraPermissionModal(true);
  //   }
  //   setcaptureOpen(false);
  // };
  // useEffect(() => {
  //   if (showWebcam) {
  //     startRealTimeFaceDetection();
  //   } else {
  //     stopFaceDetection();
  //   }
  //   return () => {
  //     stopFaceDetection();
  //   };
  // }, [showWebcam]);

  // prashanth
  // const handleCameraCapture = async () => {
  //   const video = webcamRef.current.video;

  //   const imageSrc = webcamRef.current.getScreenshot();
  //   if (!imageSrc) return;
  //   const blob = await fetch(imageSrc).then(res => res.blob());
  //   const file = new File([blob], "camera-photo.jpg", { type: "image/jpeg" });
  //   handleCaptureImageUpload({ target: { files: [file] } });

  //   setShowWebcam(false);
  // };



  const handleClosePaymentConfirmationModal = () => {
    dispatch({
      type: commonActions.SHOW_PAYMENT_CONFIRMATION_MODAL,
      payload: false,
    });
  };

  useEffect(() => {
    if ((courseid || sessionStorage.getItem("courseid")) && candidateid) {
      dispatch({
        type: candidatesActions.GET_COURSE_UPLOAD_PERSONAL_DETAILS,
        data: { courseid: courseid || sessionStorage.getItem("courseid"), candidateid: candidateid},
      });
    }
  }, [courseid, candidateid, isEditingPage]);

  const handlePayment = () => {
    //  navigate(`/${sessionStorage.getItem("mhet_cnd_project")}/confirm-payment?courseid=${EncryptFunction(courseid)}&coursename=${encodeURIComponent(
    //         courseName
    //       )}`,{ state: { courseid: courseid,coursename: courseName } })
    let encryptedParams = {
      courseid: courseid || sessionStorage.getItem("courseid"),
      isExtraFee: true,
      coursename: courseName,
      edit: true,
      subjectgroup: ""
    }
    sessionStorage.setItem("editMode", "true");
    navigate(`/${sessionStorage.getItem('mhet_cnd_project')}/confirm-payment?c_data=${EncryptObjectFunction(encryptedParams)}&courseid=${EncryptFunction(courseid)}&coursename=${encodeURIComponent(
      courseName
    )}`)
  }
  return (
    <Grid
      style={{
        padding: "20px 25px 0px 25px",
        minHeight: "60vh",
        backgroundColor: "#fff",
        borderRadius: "8px",
        display: "flex",
        flexDirection: "column",
        border: " 1px solid #0F4F96",
      }}
    >

      <Grid container >
        <Grid item lg={7}>
          <div style={{ padding: "10px", border: "none" }}>
            {/* Photo Upload */}
            <Box mb={2}>
              <Typography variant="h6" gutterBottom style={{ fontSize: "15px", width: "150px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                Photo
              </Typography>
              {showImage && (
                <>
                  <div style={{ display: 'flex' }}>
                    <div style={{ position: "relative" }}>
                      <IconButton
                        onClick={() => {
                          setCaptureShowCard(null);
                          setShowCard(null);
                          setUploadValue();
                          handleCaptureIconClick()
                        }}
                        style={{
                          position: "absolute",
                          top: "-10px",
                          left: "136px",
                          backgroundColor: "#FFFFFF",
                          borderRadius: "50%",
                          padding: "1px",
                          backgroundColor: "#0F4F96",
                          border: " 2.08px solid #FFFFFF",
                        }}
                      >
                        <LuPencilLine
                          style={{ color: "#ffffff", width: "19px", height: "19px" }}
                        />
                      </IconButton>
                      <img
                        src={showImage}
                        alt="Original Image"
                        style={{
                          height: "160px",
                          width: "150px",
                          borderRadius: 2,
                          border: '1px solid #0f4f96',
                        }}
                      />
                    </div>
                    {showCompressedImage && photoSize > 5120 && (
                      <Box style={{
                        height: "160px",
                        width: "150px",
                        borderRadius: 2,
                        // border: '1px solid #0f4f96',
                        marginLeft: "20px"
                      }}>
                        <img
                          src={showCompressedImage}
                          alt="Compressed Image"
                          style={{ height: "160px", width: "150px", borderRadius: 2, border: '1px solid #0f4f96', }}
                        />
                        <Box
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                          }}
                        >
                          <Typography
                            variant="caption"
                            style={{ paddingTop: "10px" }}
                          >
                            Compressed image
                          </Typography>
                        </Box>
                        {cropPhotoImage !== "" && (
                          <small className="photo-size" style={{ display: "flex" }}>{photoSizeCompressed.toFixed(2)} KB
                          </small>
                        )}
                      </Box>
                    )}</div>

                  {cropPhotoImage !== "" && photoSize > 5120 && (
                    <small className="photo-size">{photoSize} KB</small>
                  )}
                  {photoCheckError && (
                    <small className="error">{photoCheckError}</small>
                  )}
                </>
              )}
              {!showImage && uploadDetails?.find((item, index) => item?.documenttype == 1)?.fileurl && (
                <>
                  <div style={{ position: "relative" }}>

                    <img
                      // src={uploadDetails?.find((item, index) => item?.documenttype == 1)?.fileurl}
                      src={photoURL}
                      alt="Original Image"
                      style={{
                        height: "160px",
                        width: "150px",
                        borderRadius: 2,
                        border: '1px solid #0f4f96',
                      }}
                    />
                    <IconButton
                      onClick={() => {
                        setCaptureShowCard(null);
                        setShowCard(null);
                        setUploadValue()
                        handleCaptureIconClick()
                      }}
                      style={{
                        position: "absolute",
                        top: "-10px",
                        left: "136px",
                        backgroundColor: "#FFFFFF",
                        borderRadius: "50%",
                        padding: "1px",
                        backgroundColor: "#0F4F96",
                        border: " 2.08px solid #FFFFFF",
                      }}
                    >
                      <LuPencilLine
                        style={{ color: "#ffffff", width: "19px", height: "19px" }}
                      />
                    </IconButton>
                  </div>
                  {photoError && !cropPhotoImage && (
                    <small className="error">{photoError}</small>
                  )}
                  <br />
                  {photoCheckError && (
                    <small className="error">{photoCheckError}</small>
                  )}
                </>
              )}
              {!open && !captureOpen && !showImage
                && !uploadDetails?.find((item, index) => item?.documenttype == 1)?.fileurl
                && (<>
                  <Box
                    sx={{
                      border: '1px dashed #0f4f96',
                      py: 4,
                      textAlign: 'center',
                      cursor: 'pointer',
                      borderRadius: 2,
                      width: "150px",
                      height: "160px",
                      borderStyle: 'dashed',
                      borderWidth: '2px',

                    }}
                    onClick={handleCaptureIconClick}
                  >
                    <BsCardImage color="#c6d2df" size={60} />
                    <Typography variant="caption" style={{ fontSize: "12px", color: "#0f4f96", display: "flex", alignItems: "center", justifyContent: "center" }}>
                      ADD PHOTO
                    </Typography>
                  </Box>
                  {photoError && <small className="error">{photoError}</small>}
                  <br />
                  {photoCheckError && (
                    <small className="error">{photoCheckError}</small>
                  )}
                </>
                  // handleImageCaptureShow
                )}
            </Box>

            {/* Signature Upload */}
            <Box mb={2} mt={4}>
              <Typography variant="h6" gutterBottom style={{ fontSize: "15px", width: "250px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                Signature
              </Typography>
              {showSignature && (
                <>
                  <div style={{ display: 'flex' }}>
                    <div style={{ position: "relative" }}>
                      <img
                        src={showSignature}
                        alt="Original Signature"
                        style={{ position: "relative", height: "140px", width: "250px", borderRadius: "4px" }}

                      />
                      <IconButton
                        onClick={() => {
                          setSignatureShowCard(null)
                          handleIconClickSignature()
                        }}
                        style={{
                          position: "absolute",
                          top: "-10px",
                          left: "232px",
                          backgroundColor: "#FFFFFF",
                          borderRadius: "50%",
                          padding: "1px",
                          backgroundColor: "#0F4F96",
                          border: " 2.08px solid #FFFFFF",
                        }}
                      >
                        <LuPencilLine
                          style={{ color: "#ffffff", width: "19px", height: "19px" }}
                        />
                      </IconButton>
                    </div>
                    {showCompressedSignature && signatureSize > 300 && (
                      <Box style={{ height: "140px", width: "250px", borderRadius: "4px", marginLeft: "8px" }}>
                        <img
                          src={showCompressedSignature}
                          alt="Compressed Signature"
                          // style={{ height: "140px", width: "auto", borderRadius: "4px" }}
                          style={{
                            height: "140px", width: "250px", borderRadius: "4px"
                          }}
                        />
                        <Box
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                          }}
                        >
                          <Typography
                            variant="caption"
                            style={{ paddingTop: "10px" }}
                          >
                            Compressed signature
                          </Typography>
                        </Box>
                        {cropSignatureImage !== "" && (
                          <small className="photo-size">
                            {(signatureSizeCompressed.size / 1024).toFixed(2)} KB
                          </small>
                        )}
                      </Box>
                    )}
                  </div>
                  {cropSignatureImage !== "" && signatureSize > 300 && (
                    <small className="photo-size">{signatureSize} KB</small>
                  )}
                  {signatureCheckError && (
                    <small className="error">{signatureCheckError}</small>
                  )}
                </>
              )}
              {!showSignature && uploadDetails?.find((item, index) => item?.documenttype == 2)?.fileurl && (
                <>
                  <div style={{ position: "relative" }}>
                    <img
                      // src={uploadDetails?.find((item, index) => item?.documenttype == 2)?.fileurl}
                      src={signURL}
                      alt="Original Signature"
                      style={{ position: "relative", height: "140px", width: "250px", borderRadius: "4px" }}

                    />
                    <IconButton
                      onClick={() => {
                        setSignatureShowCard(null);
                        handleIconClickSignature()
                      }}
                      style={{
                        position: "absolute",
                        top: "-10px",
                        left: "232px",
                        backgroundColor: "#FFFFFF",
                        borderRadius: "50%",
                        padding: "1px",
                        backgroundColor: "#0F4F96",
                        border: " 2.08px solid #FFFFFF",
                      }}
                    >
                      <LuPencilLine
                        style={{ color: "#ffffff", width: "19px", height: "19px" }}
                      />
                    </IconButton>
                  </div>
                  {signatureError && !cropSignatureImage && (
                    <small className="error">{signatureError}</small>
                  )}
                  <br />
                  {signatureCheckError && (
                    <small className="error">{signatureCheckError}</small>
                  )}
                </>
              )}
              {!open && !showSignature && !uploadDetails?.find((item, index) => item?.documenttype == 2)?.fileurl && (
                <>
                  <Box
                    sx={{
                      border: '1px dashed #0f4f96',
                      py: 4,
                      textAlign: 'center',
                      cursor: 'pointer',
                      borderRadius: 2,
                      width: "250px",
                      height: "140px",
                      borderStyle: 'dashed',
                      borderWidth: '2px',
                    }}
                    onClick={handleIconClickSignature}
                  >
                    <BsCardImage color="#c6d2df" size={60} />
                    <Typography variant="caption" style={{ fontSize: "12px", color: "#0f4f96", display: "flex", alignItems: "center", justifyContent: "center" }}>
                      ADD PHOTO
                    </Typography>
                  </Box>
                  {signatureError && (
                    <small className="error">{signatureError}</small>
                  )}
                  <br />
                  {signatureCheckError && (
                    <small className="error">{signatureCheckError}</small>
                  )}
                </>
              )}
            </Box>
            {(!showSignature && !uploadDetails?.find((item, index) => item?.documenttype == 2)?.fileurl) && (
              <Typography
                mb={2}
                variant="body1"
                style={{ width: "250px", display: "flex", alignItems: "center", justifyContent: "center" }}
                sx={{
                  color: "#0000008A",
                  lineHeight: "22px",
                }}
              >
                (JPEG,JPG or png)
                <br />
                (max size - 2048 kB)
              </Typography>
            )}


            {/* Document Upload */}

            {/* <Box mb={4}  ref={doctyperef}>
              <Typography variant="h6" gutterBottom style={{fontSize:"15px",fontWeight:"bold"}}>
                Photo Identity *
              </Typography>
              <div style={{display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                
              <TextField
                select
                label="Select Document Type *"
                style={{ width: "48%"}}
                size="small"
                value={documentid}
                id="documentid"
                ref={doctyperef}
                onChange={handleDocumentId}
                sx={{mb: 2}}
              >
                {documentType?.map((val, i) => (
                <MenuItem  sx={{ textWrap: "wrap" }}
                        value={val?.documenttypeid}
                        key={i}
> {val?.documenttype}</MenuItem> ))}
              </TextField>
              
              <Button sx={{mb: 2}} variant="outlined" component="label" style={{color:"#757575",border:"1px solid #757575", width: '48%',height:"40px",display:"flex",justifyContent:"space-between"}} >
                <span>Choose File To Upload</span>
                
                <input type="file" hidden />
                <GrAttachment />
              </Button>
              </div>
              <Typography sx={{mt:-2}} variant="caption" style={{display:"flex",justifyContent:"right",fontSize:"14px",color:"#757575"}}>
                (PDF, JPEG, JPG or PNG) (Max Size 1MB)
              </Typography>

            </Box> */}
            {!isEditingPage && <>
              <InputLabel htmlFor="document" style={{ fontWeight: "bold" }} ref={doctyperef}>
                Photo Identity
                <span className="error" style={{ color: "#666666" }}>
                  *
                </span>
              </InputLabel>
              <Grid
                container
                md={12}
                spacing={1}

                sx={{ display: "flex" }}
                style={{ display: "flex" }}
              >
                <Grid
                  ref={doctyperef}
                  container
                  xs={12} sm={12} md={6} lg={6}
                  spacing={1}
                  mt={1}
                  sx={{ display: "flex" }}
                >
                  <Grid item xs={12} md={10} sx={{ marginLeft: "7px", marginRight: "8px" }} ref={doctyperef}>
                    <FormControl fullWidth ref={doctyperef}>
                      <StyledLabel id="select-doc-label"
                      >
                        Select Document Type*
                      </StyledLabel>
                      <Select
                        label="Select Document Type*"
                        value={documentid}
                        id="documentid"
                        onChange={handleDocumentId}
                        sx={{
                          borderRadius: "8px",
                          height: "40px",
                        }}
                        renderValue={(selected) => {
                          const selectedItem = documentType?.find(val => val.documenttypeid === selected);
                          const text = selectedItem?.documenttype || "";

                          // 27 characters ke baad cut karna
                          return text.length > 27 ? text.slice(0, 27) + "..." : text;
                        }}
                        size="small"
                        ref={doctyperef}
                      >
                        <MenuItem value="" disabled>Select One</MenuItem>
                        {documentType?.map((val, i) => (
                          <MenuItem
                            sx={{ textWrap: "wrap" }}
                            value={val?.documenttypeid}
                            key={i}
                          >
                            <span style={{ textWrap: "wrap" }}>
                              {val?.documenttype}
                            </span>
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>


                  {documentName && (
                    <Grid item md={10}
                      ref={docref}>
                      <Box
                        style={{
                          height: "fit-content",
                          border: "1px solid #D5D5D5",
                          display: "flex",
                          alignItems: "center",
                          padding: "8px",
                          marginTop: "1rem",
                          margin: "6px 0px 0px 8px",
                          borderRadius: "8px",
                          position: "relative",
                          overflow: "hidden",

                        }}

                      >
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            flexGrow: 1,
                            overflow: "hidden",
                          }}
                        >
                          <img
                            src={filetype === "docx" ? word :
                              filetype === "pdf" ? pdf :
                                filetype === "jpeg" ? jpeg :
                                  filetype === "png" ? png :
                                    null
                            }
                            style={{ height: "auto", width: "30px", marginLeft: "5px" }}
                            alt="pdf"
                          />
                          <span
                            style={{
                              wordBreak: "break-word",
                              whiteSpace: "normal",
                              paddingRight: "24px",
                            }}
                          >
                            {documentName}
                          </span>
                        </Box>
                        <Box
                          style={{
                            position: "relative",
                            right: "10px",
                            marginLeft: "auto",
                            cursor: "pointer",
                          }}
                          onClick={handleCloseDocument}
                        >
                          <PiX />
                        </Box>
                      </Box>
                    </Grid>
                  )}



                  {(documentTypeError && !documentid) && (
                    <small
                      className="error"
                      style={{ padding: "0px 8px", marginTop: ".2rem" }}
                    >
                      &nbsp; &nbsp; {documentTypeError}
                    </small>
                  )}
                </Grid>

                <Grid item xs={12} sm={12} md={6} lg={6} mt={-1}>
                  <Box
                    style={{
                      border: "1px solid #0000003D",
                      borderRadius: "8px",
                      // maxWidth: "280px",
                      height: "42px",
                      display: "flex",
                      alignItems: "center",
                      marginTop: "16px",
                      padding: "0px",
                    }}
                  >
                    <input
                      type="file"
                      name="documentfilename"
                      id="documentfilename"
                      // accept=".jpeg,.jpg,.png,.pdf,.doc,.docx"
                      accept=".jpeg,.jpg,.pdf"
                      style={{
                        width: "0.1px",
                        height: "0.1px",
                        opacity: 0,
                        overflow: "hidden",
                        position: "absolute",
                        zIndex: -1,
                      }}
                      onChange={handleDocumentUpload}
                    />
                    <label
                      htmlFor="documentfilename"
                      style={{
                        cursor: "pointer",
                        display: "flex",
                        padding: "18px",
                        width: "100%",
                        alignItems: "center",
                        justifyContent: "space-between",
                        color: "0000003D",
                      }}
                    >
                      {uploadDetails && uploadDetails[2]?.filename
                        ? "Upload New Document*"
                        : "Upload Document*"}
                      <GrAttachment size={22} />
                    </label>
                  </Box>
                  <small
                    className="error"
                    style={{ color: "#666666", textWrap: "wrap" }}
                  >
                    {" "}

                    {`Only JPG and PDF files are allowed  (File size max of 2 MB)`}
                  </small><br />
                  {documentError && !documentfilename && (
                    <small className="error">{documentError}</small>
                  )}
                </Grid>
                {uploadDetails?.find((item, index) => item?.documenttype == 3) &&
                  !documentName && (
                    <>
                      <Grid item md={5} lg={5} mt={-5} ml={-1}>
                        <Box
                          style={{
                            height: "fit-content",
                            border: "1px solid #D5D5D5",
                            display: "flex",
                            alignItems: "center",
                            padding: "8px",
                            marginTop: "1rem",
                            margin: "6px 0px 0px 8px",
                            borderRadius: "8px",
                            position: "relative",
                            overflow: "hidden",

                          }}

                        >
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                              flexGrow: 1,
                              overflow: "hidden",
                            }}
                          >
                            <img
                              src={
                                fileTypes[3] === "word" || fileTypes[3] === "docx"
                                  ? word
                                  : fileTypes[3] === "pdf"
                                    ? pdf
                                    : fileTypes[3] === "jpeg" || fileTypes[3] === "jpg"
                                      ? jpeg
                                      : fileTypes[3] === "png"
                                        ? png
                                        : null
                              }
                              style={{
                                height: "auto",
                                width: "30px",
                                marginLeft: "5px",
                              }}
                              alt="file-type-icon"
                            />
                            <span
                              style={{
                                wordBreak: "break-word",
                                whiteSpace: "normal",
                                fontSize: "14px",
                                color: "#333",
                              }}
                            >
                              {uploadDetails
                                ? uploadDetails?.find(
                                  (item) => item?.documenttype === 3
                                )?.filename
                                : "Document name"}
                            </span>
                          </Box>


                          <Box
                            style={{
                              backgroundColor: "#f0f0f0",
                              padding: "6px 12px",
                              borderRadius: "4px",
                              cursor: "pointer",
                              fontSize: "14px",
                              color: "#007BFF",
                              fontWeight: "bold",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                            onClick={() => {
                              const targetUrl = uploadDetails
                                ? uploadDetails.find(
                                  (item) => item?.documenttype === 3
                                )?.fileurl
                                : "";

                              if (targetUrl) {
                                window.open(
                                  targetUrl,
                                  "_blank",
                                  "noopener,noreferrer"
                                );
                              } else {
                                console.error("No URL found to redirect to.");
                              }
                            }}
                          >
                            <FiEye />
                          </Box>
                        </Box>
                      </Grid>
                    </>
                  )}
              </Grid>
            </>}

            {isdisability === "1" && !isEditingPage && (
              <div style={{ marginTop: '2%' }}>
                <InputLabel htmlFor="udiddocument" style={{ fontWeight: "bold" }} ref={doctyperef}>
                  UDID / Disability Certificate
                  <span className="error" style={{ color: "#666666", marginTop: '1rem' }}>*</span>
                </InputLabel>

                <Grid container md={12} spacing={2} alignItems="flex-start" sx={{ display: "flex" }}>

                  {/* ******* Upload Box ******* */}
                  <Grid item xs={12} sm={12} md={6} lg={6} mt={-1}>
                    <Box
                      style={{
                        border: "1px solid #0000003D",
                        borderRadius: "8px",
                        // maxWidth: "280px",
                        height: "42px",
                        display: "flex",
                        alignItems: "center",
                        marginTop: "16px",
                        padding: "0px",
                      }}
                    >
                      <input
                        type="file"
                        name="udiddocument"
                        id="udiddocument"
                        // accept=".jpeg,.jpg,.png,.pdf,.doc,.docx"
                        accept=".jpeg,.jpg,.pdf"
                        style={{
                          width: "0.1px",
                          height: "0.1px",
                          opacity: 0,
                          overflow: "hidden",
                          position: "absolute",
                          zIndex: -1,
                        }}
                        onChange={handlePwdDocumentUpload}
                      />
                      <label
                        htmlFor="udiddocument"
                        style={{
                          cursor: "pointer",
                          display: "flex",
                          padding: "18px",
                          width: "100%",
                          alignItems: "center",
                          justifyContent: "space-between",
                          color: "0000003D",
                        }}
                      >
                        {pwdDocument.udiddocument
                          ? "Upload New Document*"
                          : "Upload Document*"}
                        <GrAttachment size={22} />
                      </label>
                    </Box>

                    {/* File Type Note */}
                    <small className="error" style={{ color: "#666666" }}>
                      Only JPG and PDF files allowed (Max 2 MB)
                    </small>
                    <br />

                    {/* Error Message */}
                    {pwdDocumentError.udiddocument && (
                      <small className="error">{pwdDocumentError.udiddocument}</small>
                    )}
                  </Grid>

                  {/* ******* NEW UPLOADED DOCUMENT PREVIEW ******* */}
                  {pwdDocument.udiddocument && (
                    <Grid item xs={12} sm={12} md={6} lg={6} mt={-1}>
                      <Box
                        style={{
                          height: "fit-content",
                          border: "1px solid #D5D5D5",
                          display: "flex",
                          alignItems: "center",
                          padding: "8px",
                          marginTop: "1rem",
                          borderRadius: "8px",
                        }}
                      >
                        <Box sx={{ display: "flex", gap: "8px", flexGrow: 1 }}>
                          <img
                            src={
                              pwdDocument.udiddocument.type.includes("pdf")
                                ? pdf
                                : jpeg
                            }
                            style={{ width: "30px" }}
                          />
                          <span style={{ wordBreak: "break-word" }}>
                            {pwdDocument.udiddocument.name}
                          </span>
                        </Box>

                        <Box
                          style={{
                            cursor: "pointer", position: "relative",
                            right: "10px",
                            marginLeft: "auto",
                          }}
                          onClick={() =>
                            setPwdDocument((prev) => ({ ...prev, udiddocument: null }))
                          }
                        >
                          <PiX />
                        </Box>
                      </Box>
                    </Grid>
                  )}

                  {/* ******* OLD DOCUMENT PREVIEW (from API) ******* */}
                  {!pwdDocument.udiddocument &&
                    uploadDetails?.find((item) => item.documenttype === 4) && (
                      <Grid item xs={12} sm={12} md={6} lg={6} mt={-1}>
                        <Box
                          style={{
                            height: "fit-content",
                            border: "1px solid #D5D5D5",
                            display: "flex",
                            alignItems: "center",
                            padding: "8px",
                            marginTop: "1rem",
                            borderRadius: "8px",
                          }}
                        >
                          <Box sx={{ display: "flex", gap: "8px", flexGrow: 1 }}>
                            <img
                              src={
                                fileTypes[4] === "pdf"
                                  ? pdf
                                  : fileTypes[4] === "jpeg" || "jpg"
                                    ? jpeg
                                    : null
                              }
                              style={{ width: "30px" }}
                            />
                            <span style={{ wordBreak: "break-word" }}>
                              {
                                uploadDetails.find(
                                  (item) => item.documenttype === 4
                                )?.filename
                              }
                            </span>
                          </Box>

                          <Box
                            style={{
                              backgroundColor: "#f0f0f0",
                              padding: "6px 12px",
                              borderRadius: "4px",
                              cursor: "pointer",
                              fontSize: "14px",
                              color: "#007BFF",
                              fontWeight: "bold",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                            onClick={() => {
                              const targetUrl = uploadDetails
                                ? uploadDetails.find(
                                  (item) => item?.documenttype === 4
                                )?.fileurl
                                : "";

                              if (targetUrl) {
                                window.open(
                                  targetUrl,
                                  "_blank",
                                  "noopener,noreferrer"
                                );
                              } else {
                                console.error("No URL found to redirect to.");
                              }
                            }}
                          >
                            <FiEye />
                          </Box>
                        </Box>
                      </Grid>
                    )}
                </Grid>
              </div>
            )}

            {/* Annexure1 Document */}
            {((isdisability === "1" && !isEditingPage && otherDetails[0]?.isscriberequired === "1" && isPwdAllowed) && !(process.env.REACT_APP_HIDE_LAST_APPENDIX_DOC?.split(",")?.map((id) => id?.trim())?.includes(courseid || sessionStorage.getItem("courseid")))) && (
              <div style={{ marginTop: '2%' }}>
                <InputLabel htmlFor="annexuredocument" style={{ fontWeight: "bold" }} ref={doctyperef}>
                  Appendix 1 & 2 / Medical Certificate
                  <span className="error" style={{ color: "#666666" }}>*</span>
                </InputLabel>

                <Grid container md={12} spacing={2} alignItems="flex-start" sx={{ display: "flex" }}>
                  <Grid style={{ marginTop: "1rem", marginLeft: "1rem" }}>
                    <p style={{ color: "#0F4F96", fontWeight: "bold", fontSize: "14px" }}>Use Appendix 1 for PWD below 40% disability and Appendix 2 for PWD with 40% or above disability.</p>
                  </Grid>
                  <Grid style={{ marginTop: "1rem", marginLeft: "1rem" }}>
                    <a
                      href={gcpUrl}
                      target="_blank"
                      rel="noreferrer"
                      style={{
                        fontSize: '14px',
                        color: "#0F4f96",
                        textDecoration: "underline",
                        cursor: "pointer",
                      }}
                    >
                      Please download the Appendix 1 & 2/ Medical Certificate Document. Fill and then upload the same.
                    </a>
                  </Grid>

                  {/* ******* Upload Box ******* */}
                  <Grid item xs={12} sm={12} md={6} lg={6} mt={-1}>
                    <Box
                      style={{
                        border: "1px solid #0000003D",
                        borderRadius: "8px",
                        // maxWidth: "280px",
                        height: "42px",
                        display: "flex",
                        alignItems: "center",
                        marginTop: "16px",
                        padding: "0px",
                      }}
                    >
                      <input
                        type="file"
                        name="annexuredocument"
                        id="annexuredocument"
                        // accept=".jpeg,.jpg,.png,.pdf,.doc,.docx"
                        accept=".jpeg,.jpg,.pdf"
                        style={{
                          width: "0.1px",
                          height: "0.1px",
                          opacity: 0,
                          overflow: "hidden",
                          position: "absolute",
                          zIndex: -1,
                        }}
                        onChange={handlePwdDocumentUpload}
                      />
                      <label
                        htmlFor="annexuredocument"
                        style={{
                          cursor: "pointer",
                          display: "flex",
                          padding: "18px",
                          width: "100%",
                          alignItems: "center",
                          justifyContent: "space-between",
                          color: "0000003D",
                        }}
                      >
                        {pwdDocument.annexuredocument
                          ? "Upload New Document*"
                          : "Upload Document*"}
                        <GrAttachment size={22} />
                      </label>
                    </Box>

                    {/* File Type Note */}
                    <small className="error" style={{ color: "#666666" }}>
                      Only JPG and PDF files allowed (Max 2 MB)
                    </small>
                    <br />

                    {/* Error Message */}
                    {pwdDocumentError.annexuredocument && (
                      <small className="error">{pwdDocumentError.annexuredocument}</small>
                    )}
                  </Grid>

                  {/* ******* NEW UPLOADED DOCUMENT PREVIEW ******* */}
                  {pwdDocument.annexuredocument && (
                    <Grid item xs={12} sm={12} md={6} lg={6} mt={-1}>
                      <Box
                        style={{
                          height: "fit-content",
                          border: "1px solid #D5D5D5",
                          display: "flex",
                          alignItems: "center",
                          padding: "8px",
                          marginTop: "1rem",
                          borderRadius: "8px",
                        }}
                      >
                        <Box sx={{ display: "flex", gap: "8px", flexGrow: 1 }}>
                          <img
                            src={
                              pwdDocument.annexuredocument.type.includes("pdf")
                                ? pdf
                                : jpeg
                            }
                            style={{ width: "30px" }}
                          />
                          <span style={{ wordBreak: "break-word" }}>
                            {pwdDocument.annexuredocument.name}
                          </span>
                        </Box>

                        <Box
                          style={{
                            cursor: "pointer", position: "relative",
                            right: "10px",
                            marginLeft: "auto",
                          }}
                          onClick={() =>
                            setPwdDocument((prev) => ({ ...prev, annexuredocument: null }))
                          }
                        >
                          <PiX />
                        </Box>
                      </Box>
                    </Grid>
                  )}

                  {/* ******* OLD DOCUMENT PREVIEW (from API) ******* */}
                  {!pwdDocument.annexuredocument &&
                    uploadDetails?.find((item) => item.documenttype === 5 && item?.filename !== null) && (
                      <Grid item xs={12} sm={12} md={6} lg={6} mt={-1}>
                        <Box
                          style={{
                            height: "fit-content",
                            border: "1px solid #D5D5D5",
                            display: "flex",
                            alignItems: "center",
                            padding: "8px",
                            marginTop: "1rem",
                            borderRadius: "8px",
                          }}
                        >
                          <Box sx={{ display: "flex", gap: "8px", flexGrow: 1 }}>
                            <img
                              src={
                                fileTypes[5] === "pdf"
                                  ? pdf
                                  : fileTypes[5] === "jpeg" || "jpg"
                                    ? jpeg
                                    : null
                              }
                              style={{ width: "30px" }}
                            />
                            <span style={{ wordBreak: "break-word" }}>
                              {
                                uploadDetails.find(
                                  (item) => item.documenttype === 5
                                )?.filename
                              }
                            </span>
                          </Box>

                          <Box
                            style={{
                              backgroundColor: "#f0f0f0",
                              padding: "6px 12px",
                              borderRadius: "4px",
                              cursor: "pointer",
                              fontSize: "14px",
                              color: "#007BFF",
                              fontWeight: "bold",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                            onClick={() => {
                              const targetUrl = uploadDetails
                                ? uploadDetails.find(
                                  (item) => item?.documenttype === 5
                                )?.fileurl
                                : "";

                              if (targetUrl) {
                                window.open(
                                  targetUrl,
                                  "_blank",
                                  "noopener,noreferrer"
                                );
                              } else {
                                console.error("No URL found to redirect to.");
                              }
                            }}
                          >
                            <FiEye />
                          </Box>
                        </Box>
                      </Grid>
                    )}
                </Grid>
              </div>
            )}


            {/* {documentError && !documentfilename && (
            <small className="error">{documentError}</small>
          )} */}
          </div>
          {/* {uploadDetails?.find((item, index) => item?.documenttype == 1)
            ?.fileurl && !showImage ? (
            <Box style={{ display: "flex", flexDirection: "column" }}>
              <InputLabel style={{ fontWeight: "bold" }} ref={fileInputRef}>
                Upload Image
                <span className="error" style={{ color: "#666666" }}>
                  *
                </span>
              </InputLabel>
             
              <Box
                sx={{
                  display: "flex",
                  gap: "2%",
                  marginTop: ".4rem",
                  flexDirection: isMobile ? "column" : "",
                }}
              >
               
                <Box style={{ display: "flex", flexDirection: "column" }}>
                  <Box
                    style={{
                      position: "relative",
                      display: "inline-block",
                      width: "150px",
                    }}
                  >
                    <img
                      src={
                        uploadDetails?.find(
                          (item, index) => item?.documenttype == 1
                        )?.fileurl
                      }
                      alt="Original Image"
                      style={{
                        height: "140px",
                        width: "auto",
                        borderRadius: "4px",
                      }}
                    />
<Tooltip title="Upload Photo" arrow
                       PopperProps={{
                        modifiers: [
                          {
                            name: 'offset',
                            options: {
                              offset: [0, -10], // Move tooltip 10px further up
                            },
                          },
                        ],
                      }}>
                    <IconButton
                      onClick={handleIconClick} // Trigger the file input when the icon is clicked
                      style={{
                        position: "absolute",
                        top: "-5px",
                        right: "-11px",
                        backgroundColor: "#0F4F96",
                        borderRadius: "50%",
                        padding: "4px",
                        color: "#ffffff",
                        border: "2px solid #FFFFFF",
                      }}
                    >
                      <LuPencilLine style={{ width: "16px", height: "16px" }} />
                    </IconButton>
                    </Tooltip>
                    <Tooltip title="Capture Live Photo" arrow
                       PopperProps={{
                        modifiers: [
                          {
                            name: 'offset',
                            options: {
                              offset: [0, -10], // Move tooltip 10px further up
                            },
                          },
                        ],
                      }}>
                      <IconButton
                    onClick={handleCaptureIconClick} // Handle click to trigger file input
                    style={{
                      position: "absolute",
                      top: "20px",
                      right: "-11px",
                      backgroundColor: "#0F4F96",
                      borderRadius: "50%",
                      padding: "4px",
                      border: "2.08px solid #FFFFFF",
                      color:"#ffffff"
                    }}
                  >
                    <MdCameraAlt style={{  width: "19px", height: "19px" }} />
                 </IconButton>
                 </Tooltip>
                    <input
                      ref={fileInputRef}
                      type="file"
                      name="photofilename"
                      id="photofilename"
                      accept=".jpg, .jpeg, .png"
                      style={{ display: "none" }} // Hide the input
                      onChange={handleImageUpload} // Handle file upload
                    />
                  </Box>
                </Box>
              </Box>
              <Modal open={showWebcam} onClose={() => setShowWebcam(false)}>
  <Box
    sx={{
      position: "absolute",
      top: "50%",
      left: "50%",
      width: 300,
      transform: "translate(-50%, -50%)",
      bgcolor: "background.paper",
      boxShadow: 24,
      p: 4,
      borderRadius: 2
    }}
  >
    <Webcam
      ref={webcamRef}
      screenshotFormat="image/jpeg"
      style={{ width: "100%", borderRadius: 8 , border: `2px solid ${borderColor}`, 
      boxSizing: "border-box"}}
    />
    <Box mt={2} display="flex" justifyContent="space-between">
      <Button variant="contained" onClick={handleCameraCapture}>
        Capture
      </Button>
      <Button onClick={() => setShowWebcam(false)}>Cancel</Button>
      
    </Box>
  </Box>
</Modal>

<Modal open={cameraPermissionModal} onClose={() => setCameraPermissionModal(false)}>
  <Box
    sx={{
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: 300,
      bgcolor: "background.paper",
      boxShadow: 24,
      p: 4,
      borderRadius: 2,
    }}
  >
    <Typography variant="body2" gutterBottom>
    Camera access required. Please enable or upload photo
    </Typography>
    <Box mt={2} display="flex" justifyContent="flex-end">
      <Button onClick={() => setCameraPermissionModal(false)}>Close</Button>
    </Box>
  </Box>
</Modal>
              {photoError && !cropPhotoImage && (
                <small className="error">{photoError}</small>
              )}
              <br />
              {photoCheckError && (
                <small className="error">{photoCheckError}</small>
              )}
            </Box>
          ) : showImage ? (
            <>
              <InputLabel style={{ fontWeight: "bold" }}>
                Upload Image
                <span className="error" style={{ color: "#666666" }}>
                  *
                </span>
              </InputLabel>
              <Box style={{ display: "flex", gap: "10%" }}>
                {showImage && (
                  <Box style={{ display: "flex", flexDirection: "column" }}>
                    <Box
                      style={{ position: "relative", display: "inline-block" }}
                    >
                      <img
                        src={showImage}
                        alt="Original Image"
                        style={{
                          height: "180px",
                          width: "auto",
                          borderRadius: "4px",
                        }}
                      />
                      <Tooltip title="Upload Photo" arrow
                         PopperProps={{
                          modifiers: [
                            {
                              name: 'offset',
                              options: {
                                offset: [0, -10], // Move tooltip 10px further up
                              },
                            },
                          ],
                        }}>
                      <IconButton
                        onClick={handleIconClick} // Trigger the file input when the icon is clicked
                        style={{
                          position: "absolute",
                          top: "-5px",
                          right: "-18px",
                          backgroundColor: "#0F4F96",
                          borderRadius: "50%",
                          padding: "4px",
                          color: "#ffffff",
                          border: "2px solid #FFFFFF",
                        }}
                      >
                        <LuPencilLine
                          style={{ width: "16px", height: "16px" }}
                        />
                      </IconButton>
                      </Tooltip>
                        <Tooltip title="Capture Live Photo" arrow
                        PopperProps={{
                          modifiers: [
                            {
                              name: 'offset',
                              options: {
                                offset: [0, -10], // Move tooltip 10px further up
                              },
                            },
                          ],
                        }}>
                        <IconButton
                    onClick={handleCaptureIconClick} // Handle click to trigger file input
                    style={{
                      position: "absolute",
                      top: "20px",
                      right: "-18px",
                      backgroundColor: "#0F4F96",
                      borderRadius: "50%",
                      padding: "4px",
                      border: "2px solid #FFFFFF",
                       color:"#ffffff"
                    }}
                  >
                    <MdCameraAlt style={{  width: "19px", height: "19px" }} />
                 </IconButton>
                 </Tooltip>
                    </Box>

                    <input
                      type="file"
                      ref={fileInputRef} // Reference to file input
                      name="photofilename"
                      id="photofilename"
                      accept=".jpg, .jpeg, .png"
                      style={{ display: "none" }} // Hide the input
                      onChange={handleImageUpload} // Handle file upload
                    />

                    <Typography
                      variant="caption"
                      style={{ paddingTop: "10px" }}
                    >
                      Uploaded image
                    </Typography>

                    {cropPhotoImage !== "" && photoSize > 300 && (
                      <small className="photo-size">{photoSize} KB</small>
                    )}
                  </Box>
                )}
                <Modal open={showWebcam} onClose={() => setShowWebcam(false)}>
  <Box
    sx={{
      position: "absolute",
      top: "50%",
      left: "50%",
      width: 300,
      transform: "translate(-50%, -50%)",
      bgcolor: "background.paper",
      boxShadow: 24,
      p: 4,
      borderRadius: 2
    }}
  >
    <Webcam
      ref={webcamRef}
      screenshotFormat="image/jpeg"
      style={{ width: "100%", borderRadius: 8 , border: `2px solid ${borderColor}`, 
      boxSizing: "border-box"}}
    />
    <Box mt={2} display="flex" justifyContent="space-between">
      <Button variant="contained" onClick={handleCameraCapture}>
        Capture
      </Button>
      <Button onClick={() => setShowWebcam(false)}>Cancel</Button>
      
    </Box>
  </Box>
</Modal>

<Modal open={cameraPermissionModal} onClose={() => setCameraPermissionModal(false)}>
  <Box
    sx={{
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: 300,
      bgcolor: "background.paper",
      boxShadow: 24,
      p: 4,
      borderRadius: 2,
    }}
  >
    <Typography variant="body2" gutterBottom>
    Camera access required. Please enable or upload photo.
    </Typography>
    <Box mt={2} display="flex" justifyContent="flex-end">
      <Button onClick={() => setCameraPermissionModal(false)}>Close</Button>
    </Box>
  </Box>
</Modal>
                {showCompressedImage && photoSize > 300 && (
                  <Box style={{ display: "flex", flexDirection: "column" }}>
                    <img
                      src={showCompressedImage}
                      alt="Compressed Image"
                      style={{ height: "180px", width: "auto" }}
                    />
                    <Box
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "4px",
                      }}
                    >
                      <Typography
                        variant="caption"
                        style={{ paddingTop: "10px" }}
                      >
                        Compressed image
                      </Typography>
                    </Box>
                    {cropPhotoImage !== "" && (
                      <small className="photo-size">
                        
                        {photoSizeCompressed.toFixed(2)} KB
                      </small>
                    )}
                  </Box>
                )}
              </Box>
              {photoCheckError && (
                <small className="error">{photoCheckError}</small>
              )}
            </>
          ) : (
            <>
              <InputLabel style={{ fontWeight: "bold" }}>
                Upload Image
                <span className="error" style={{ color: "#666666" }}>
                  *
                </span>
              </InputLabel>
              <Box
                style={{
                  backgroundColor: "#CFDCEA",
                  width: "120px",
                  height: "140px",
                  borderRadius: "8px",
                  padding: "3px",
                  position: "relative",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginTop: "8px",
                }}
              >
                <Tooltip title="Upload Photo" arrow
                  PopperProps={{
                    modifiers: [
                      {
                        name: 'offset',
                        options: {
                          offset: [0, -10], // Move tooltip 10px further up
                        },
                      },
                    ],
                  }}>
                <IconButton
                  onClick={handleIconClick} // Handle click to trigger file input
                  style={{
                    position: "absolute",
                    top: "-3px",
                    right: "-5px",
                    backgroundColor: "#0F4F96",
                    borderRadius: "50%",
                    padding: "1px",
                    border: "2.08px solid #FFFFFF",
                  }}
                >
                  <LuPencilLine
                    style={{ color: "#ffffff", width: "19px", height: "19px" }}
                  />
                </IconButton>
                </Tooltip>
                  
                  <Tooltip title="Capture Live Photo" arrow
                  PopperProps={{
                    modifiers: [
                      {
                        name: 'offset',
                        options: {
                          offset: [0, -10], // Move tooltip 10px further up
                        },
                      },
                    ],
                  }}>
                  <IconButton
                    onClick={handleCaptureIconClick} // Handle click to trigger file input
                    style={{
                      position: "absolute",
                      top: "20px",
                      right: "-5px",
                      backgroundColor: "#0F4F96",
                      borderRadius: "50%",
                      padding: "1px",
                      border: "2.08px solid #FFFFFF",
                       color:"#ffffff"
                    }}
                  >
                    <MdCameraAlt style={{  width: "19px", height: "19px" }} />
                 </IconButton>
                 </Tooltip>

                <input
                  type="file"
                  ref={fileInputRef} // Reference for the file input
                  name="photofilename"
                  id="photofilename"
                  accept=".jpg, .jpeg, .png"
                  style={{
                    display: "none", // Hide the file input element
                  }}
                  onChange={handleImageUpload}
                />

                <BiSolidUser
                  style={{ width: "78px", height: "78px", color: "#0F4F96" }}
                />
              </Box>
              <Typography
                variant="body1"
                mt={1}
                sx={{
                  color: "#0000008A",
                  lineHeight: "22px",
                }}
              >
                (JPEG,JPG or png)
                <br />
                (max size - 500 kB)
              </Typography>
              <Modal open={showWebcam} onClose={() => setShowWebcam(false)}>
  <Box
    sx={{
      position: "absolute",
      top: "50%",
      left: "50%",
      width: 300,
      transform: "translate(-50%, -50%)",
      bgcolor: "background.paper",
      boxShadow: 24,
      p: 4,
      borderRadius: 2
    }}
  >
    <Webcam
      ref={webcamRef}
      screenshotFormat="image/jpeg"
      style={{ width: "100%", borderRadius: 8 , border: `2px solid ${borderColor}`, 
      boxSizing: "border-box"}}
    />
    <Box mt={2} display="flex" justifyContent="space-between">
      <Button variant="contained" onClick={handleCameraCapture}>
        Capture
      </Button>
      <Button onClick={() => setShowWebcam(false)}>Cancel</Button>
      
    </Box>
  </Box>
</Modal>

<Modal open={cameraPermissionModal} onClose={() => setCameraPermissionModal(false)}>
  <Box
    sx={{
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: 300,
      bgcolor: "background.paper",
      boxShadow: 24,
      p: 4,
      borderRadius: 2,
    }}
  >
    <Typography variant="body2" gutterBottom>
    Camera access required. Please enable or upload photo
    </Typography>
    <Box mt={2} display="flex" justifyContent="flex-end">
      <Button onClick={() => setCameraPermissionModal(false)}>Close</Button>
    </Box>
  </Box>
</Modal>
              {photoError && <small className="error">{photoError}</small>}
              <br />
              {photoCheckError && (
                <small className="error">{photoCheckError}</small>
              )}
            </>
          )}

          {uploadDetails?.find((item, index) => item?.documenttype == 2)
            ?.fileurl && !showSignature ? (
            <Box style={{ display: "flex", flexDirection: "column" }}>
              <InputLabel style={{ fontWeight: "bold" }}>
                Upload Signature
                <span className="error" style={{ color: "#666666" }}>
                  *
                </span>
              </InputLabel>
              <Box
                style={{
                  display: "flex",
                  gap: "2%",
                  marginTop: ".4rem",
                  flexDirection: isMobile ? "column" : "",
                }}
              >
                <Box style={{ display: "flex", flexDirection: "column" }}>
                  <Box
                    style={{ position: "relative", display: "inline-block" }}
                  >
                    <img
                      src={
                        uploadDetails?.find(
                          (item, index) => item?.documenttype == 2
                        )?.fileurl
                      } // Second element for signature
                      alt="Original Signature"
                      style={{
                        height: "140px",
                        width: "195px",
                        borderRadius: "4px",
                      }}
                    />
                    <Tooltip title="Upload Signature" arrow
                       PopperProps={{
                        modifiers: [
                          {
                            name: 'offset',
                            options: {
                              offset: [0, -10], // Move tooltip 10px further up
                            },
                          },
                        ],
                      }}>


                    <IconButton
                      onClick={handleIconClickSignature} // Trigger the file input when the icon is clicked
                      style={{
                        position: "absolute",
                        top: "-5px",
                        right: "-18px",
                        backgroundColor: "#0F4F96",
                        borderRadius: "50%",
                        padding: "4px",
                        color: "#ffffff",
                        border: "2px solid #FFFFFF",
                      }}
                    >
                      <LuPencilLine style={{ width: "16px", height: "16px" }} />
                    </IconButton>
                    </Tooltip>

                    <input
                      type="file"
                      ref={fileInputRefSignature}
                      name="signaturefilename"
                      id="signaturefilename"
                      accept=".jpg, .jpeg, .png"
                      style={{ display: "none" }}
                      onChange={handleSignatureUpload}
                    />
                  </Box>
                </Box>
              </Box>
              {signatureError && !cropSignatureImage && (
                <small className="error">{signatureError}</small>
              )}
              <br />
              {signatureCheckError && (
                <small className="error">{signatureCheckError}</small>
              )}
            </Box>
          ) : showSignature ? (
            <>
              <InputLabel style={{ fontWeight: "bold" }}>
                Upload Signature
                <span className="error" style={{ color: "#666666" }}>
                  *
                </span>
              </InputLabel>
              <Box style={{ display: "flex", gap: "10%" }}>
                {showSignature && (
                  <Box style={{ display: "flex", flexDirection: "column" }}>
                    <Box
                      style={{ position: "relative", display: "inline-block" }}
                    >
                      
                      <img
                        src={showSignature}
                        alt="Original Signature"
                        style={{
                          height: isMobile ? "100px" : "140px",
                          width: isMobile ? "150px" : "195px",
                          borderRadius: "4px",
                        }}
                      />
                    <Tooltip title="Upload Signature" arrow
                       PopperProps={{
                        modifiers: [
                          {
                            name: 'offset',
                            options: {
                              offset: [0, -10], // Move tooltip 10px further up
                            },
                          },
                        ],
                      }}>

                      <IconButton
                        onClick={handleIconClickSignature}
                        style={{
                          position: "absolute",
                          top: "-5px",
                          right: "0",
                          backgroundColor: "#0F4F96",
                          borderRadius: "50%",
                          padding: "4px",
                          color: "#ffffff",
                          border: "2px solid #FFFFFF",
                        }}
                      >
                        <LuPencilLine
                          style={{ width: "16px", height: "16px" }}
                        />
                      </IconButton>
                      </Tooltip>
                    </Box>
                    <input
                      type="file"
                      ref={fileInputRefSignature} // Reference to file input
                      name="signaturefilename"
                      id="signaturefilename"
                      accept=".jpg, .jpeg, .png"
                      style={{ display: "none" }} // Hide the input
                      onChange={handleSignatureUpload} // Handle file upload
                    />
                    <Typography
                      variant="caption"
                      style={{ paddingTop: "10px" }}
                    >
                      Uploaded signature
                    </Typography>

                    {cropSignatureImage !== "" && signatureSize > 300 && (
                      <small className="photo-size">{signatureSize} KB</small>
                    )}
                  </Box>
                )}
                {showCompressedSignature && signatureSize > 300 && (
                  <Box style={{ display: "flex", flexDirection: "column" }}>
                    <img
                      src={showCompressedSignature}
                      alt="Compressed Signature"
                      // style={{ height: "140px", width: "auto", borderRadius: "4px" }}
                      style={{
                        height: "140px",
                        width: "195px",
                        borderRadius: "4px",
                      }}
                    />
                    <Box
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "4px",
                      }}
                    >
                      <Typography
                        variant="caption"
                        style={{ paddingTop: "10px" }}
                      >
                        Compressed signature
                      </Typography>
                    </Box>
                    {cropSignatureImage !== "" && (
                      <small className="photo-size">
                        {(signatureSizeCompressed.size / 1024).toFixed(2)} KB
                      </small>
                    )}
                  </Box>
                )}
              </Box>
              {signatureCheckError && (
                <small className="error">{signatureCheckError}</small>
              )}
            </>
          ) : (
            <>
              <br />
              <InputLabel
                htmlFor="signfilename"
                className="mt-3"
                style={{ fontWeight: "bold" }}
              >
                Upload Signature
                <span className="error" style={{ color: "#666666" }}>
                  *
                </span>
              </InputLabel>
              <Box
                style={{
                  backgroundColor: "#CFDCEA",
                  width: "100%",
                  maxWidth: "240px",
                  height: "119px",
                  borderRadius: "8px",
                  padding: "3px",
                  position: "relative",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginTop: "8px",
                }}
              >
                                    <Tooltip title="Upload Signature" arrow
                       PopperProps={{
                        modifiers: [
                          {
                            name: 'offset',
                            options: {
                              offset: [0, -10], // Move tooltip 10px further up
                            },
                          },
                        ],
                      }}>

                <IconButton
                  onClick={handleIconClickSignature}
                  style={{
                    position: "absolute",
                    top: "-3px",
                    right: "-5px",
                    backgroundColor: "#FFFFFF",
                    borderRadius: "50%",
                    padding: "1px",
                    backgroundColor: "#0F4F96",
                    border: " 2.08px solid #FFFFFF",
                  }}
                >
                  <LuPencilLine
                    style={{ color: "#ffffff", width: "19px", height: "19px" }}
                  />
                </IconButton>
                </Tooltip>
                <img
                  src={signature}
                  style={{
                    // width: "179px",
                    // height: "62px",

                    height: "140px",
                    maxWidth: "195px",
                    width: "100%",
                    objectFit: "contain",
                  }}
                />
                <input
                  type="file"
                  ref={fileInputRefSignature}
                  name="signfilename"
                  id="signfilename"
                  accept=".jpg, .jpeg, .png"
                  onChange={handleSignatureUpload}
                  style={{
                    width: "0.1px",
                    height: "0.1px",
                    opacity: 0,
                    overflow: "hidden",
                    position: "absolute",
                    zIndex: -1,
                  }}
                />
              </Box>

              <Typography
                variant="body1"
                mt={1}
                sx={{
                  color: "#0000008A",
                  lineHeight: "22px",
                }}
              >
                (JPEG,JPG or png)
                <br />
                (max size - 300 kB)
              </Typography>

              {signatureError && (
                <small className="error">{signatureError}</small>
              )}
              <br />
              {signatureCheckError && (
                <small className="error">{signatureCheckError}</small>
              )}
            </>
          )}
          <br />
          <InputLabel
            htmlFor="document"
            style={{ fontWeight: "bold" }}
            ref={doctyperef}
          >
            Photo Identity
            <span className="error" style={{ color: "#666666" }}>
              *
            </span>
          </InputLabel> */}
          {/* <Grid
            container
            mt={1}
            spacing={1}
            sx={{ display: "flex", alignItems: "center" }}
          >
            <Grid
              ref={doctyperef}
              container
              mt={1}
              spacing={1}
              sx={{ display: "flex", alignItems: "center" }}
            >
              <Grid
                item
                xs={12}
                md={10}
                sx={{ marginLeft: "7px", marginRight: "8px" }}
                ref={doctyperef}
              >
                <FormControl fullWidth ref={doctyperef}>
                  <InputLabel id="select-doc-label">
                    Select Document Type*
                  </InputLabel>
                  <Select
                    label="Select Document Type*"
                    value={documentid}
                    id="documentid"
                    onChange={handleDocumentId}
                    sx={{
                      borderRadius: "8px",
                      // maxWidth:"250px",
                      // width:'100%'
                    }}
                    ref={doctyperef}
                  >
                    <MenuItem value="" disabled>
                      Select One
                    </MenuItem>
                    {documentType?.map((val, i) => (
                      <MenuItem
                        sx={{ textWrap: "wrap" }}
                        value={val?.documenttypeid}
                        key={i}
                      >
                        <span style={{ textWrap: "wrap" }}>
                          {val?.documenttype}
                        </span>
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              {documentName && (
                <Grid item md={10} ref={docref}>
                  <Box
                    style={{
                      height: "fit-content",
                      border: "1px solid #D5D5D5",
                      display: "flex",
                      alignItems: "center",
                      padding: "8px",
                      marginTop: "1rem",
                      margin: "6px 0px 0px 8px",
                      borderRadius: "8px",
                      position: "relative",
                      overflow: "hidden",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        flexGrow: 1,
                        overflow: "hidden",
                      }}
                    >
                      <img
                        src={
                          filetype === "docx"
                            ? word
                            : filetype === "pdf"
                            ? pdf
                            : filetype === "jpeg"
                            ? jpeg
                            : filetype === "png"
                            ? png
                            : null
                        }
                        style={{
                          height: "auto",
                          width: "30px",
                          marginLeft: "5px",
                        }}
                        alt="pdf"
                      />
                      <span
                        style={{
                          wordBreak: "break-word",
                          whiteSpace: "normal",
                          paddingRight: "24px",
                        }}
                      >
                        {documentName}
                      </span>
                    </Box>
                    <Box
                      style={{
                        position: "relative",
                        right: "10px",
                        marginLeft: "auto",
                        cursor: "pointer",
                      }}
                      onClick={handleCloseDocument}
                    >
                      <PiX />
                    </Box>
                  </Box>
                </Grid>
              )}

              {documentTypeError && !documentid && (
                <small
                  className="error"
                  style={{ padding: "0px 8px", marginTop: ".2rem" }}
                >
                  &nbsp; &nbsp; {documentTypeError}
                </small>
              )}
            </Grid>
          </Grid> */}

          {/* {uploadDetails?.find((item, index) => item?.documenttype == 3) &&
            !documentName && (
              <>
                <Grid item md={10}>
                  <Box
                    component="a"
                    style={{
                      height: "60px",
                      border: "1px solid #D5D5D5",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between", // Align the content inside the box properly
                      gap: "1rem",
                      marginTop: "1rem",
                      overflow: "hidden",
                      padding: "6px 10px",
                      borderRadius: "8px",
                      cursor: "pointer",
                      textDecoration: "none", // Remove underline for anchor
                    }}
                    target="_blank"
                  >
                    
                    <Box
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px", // Add spacing between image and text
                      }}
                    >
                      <img
                        src={
                          fileType2 === "word" || fileType2 === "docx"
                            ? word
                            : fileType2 === "pdf"
                            ? pdf
                            : fileType2 === "jpeg" || fileType2 === "jpg"
                            ? jpeg
                            : fileType2 === "png"
                            ? png
                            : null
                        }
                        style={{
                          height: "40px",
                          width: "40px",
                          marginLeft: "5px",
                        }}
                        alt="file-type-icon"
                      />
                      <span
                        style={{
                          wordBreak: "break-word",
                          whiteSpace: "normal",
                          fontSize: "14px",
                          color: "#333",
                        }}
                      >
                        {uploadDetails
                          ? uploadDetails?.find(
                              (item) => item?.documenttype === 3
                            )?.filename
                          : "Document name"}
                      </span>
                    </Box>

                   
                    <Box
                      style={{
                        backgroundColor: "#f0f0f0",
                        padding: "6px 12px",
                        borderRadius: "4px",
                        cursor: "pointer",
                        fontSize: "14px",
                        color: "#007BFF",
                        fontWeight: "bold",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      onClick={() => {
                        const targetUrl = uploadDetails
                          ? uploadDetails.find(
                              (item) => item?.documenttype === 3
                            )?.fileurl
                          : "";

                        if (targetUrl) {
                          window.open(
                            targetUrl,
                            "_blank",
                            "noopener,noreferrer"
                          );
                        } else {
                          console.error("No URL found to redirect to.");
                        }
                      }}
                    >
                      <FiEye />
                    </Box>
                  </Box>
                </Grid>
              </>
            )} */}
          {/* <Grid item md={10}>
            <Box
              style={{
                border: "1px solid #0000003D",
                borderRadius: "8px",
                // maxWidth: "280px",
                minHeight: "52px",
                display: "flex",
                alignItems: "center",
                marginTop: "16px",
                padding: "0px",
              }}
            >
              <input
                type="file"
                name="documentfilename"
                id="documentfilename"
                // accept=".jpeg,.jpg,.png,.pdf,.doc,.docx"
                accept=".jpeg,.jpg,.pdf"
                style={{
                  width: "0.1px",
                  height: "0.1px",
                  opacity: 0,
                  overflow: "hidden",
                  position: "absolute",
                  zIndex: -1,
                }}
                onChange={handleDocumentUpload}
              />
              <label
                htmlFor="documentfilename"
                style={{
                  cursor: "pointer",
                  display: "flex",
                  padding: "18px",
                  width: "100%",
                  alignItems: "center",
                  justifyContent: "space-between",
                  color: "0000003D",
                }}
              >
                {uploadDetails && uploadDetails[2]?.filename
                  ? "Upload New Document"
                  : "Upload Document"}
                <GrAttachment size={22} />
              </label>
            </Box>
          </Grid> */}
          {/* <small
            className="error"
            style={{ color: "#666666", textWrap: "wrap" }}
          >
            {" "}
           
            {`Only JPG and PDF files are allowed  (File size max of 2 MB)`}
          </small>
          <br />
          {documentError && !documentfilename && (
            <small className="error">{documentError}</small>
          )} */}
        </Grid>
        <Grid item lg={5}>
          <Box
            sx={{
              minHeight: "5rem",
              maxWidth: "541px",
              padding: "1rem",
              backgroundColor: "#F3F6FA",
              marginTop: "10px",
              marginBottom: "10px",
              border: "1px solid #0F4F96",
              borderRadius: "20px",
            }}
          >
            <Typography variant="h6" sx={{ color: "#504E50", fontWeight: 500 }}>
              Instructions for Photo:-
            </Typography>
            <Grid container spacing={1} sx={{ marginTop: "1rem" }}>
              <Grid item xs={12}>
                <Typography variant="body2" sx={{ color: "#504E50" }}>
                  1. Recent colour photo (last 6 months) with plain & light background.
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="body2" sx={{ color: "#504E50" }}>
                  2. Face straight, looking at camera, covering 50–70%; ears and eyes clearly visible.
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="body2" sx={{ color: "#504E50" }}>
                  3. Size: 15 KB – 5 MB | Format: JPG/JPEG/PNG | 3.5 × 4.5 cm (350×450 px min, 1000×1200 px max).
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="body2" sx={{ color: "#504E50" }}>
                  4. No caps/sunglasses. Religious headgear allowed only if full face is visible.
                </Typography>
              </Grid>
              {/* <Grid item xs={12}>
                <Typography variant="body2" sx={{ color: "#504E50" }}>
                  5. Ensure your photo is well-lit with no shadows on your face
                  or in the background.
                </Typography>
              </Grid> */}
            </Grid>

            <Typography
              variant="h6"
              sx={{ color: "#504E50", fontWeight: 500, marginTop: "1rem" }}
            >
              Instructions for Signature:-
            </Typography>
            <Grid container spacing={1} sx={{ marginTop: "1rem" }}>
              <Grid item xs={12}>
                <Typography variant="body2" sx={{ color: "#504E50" }}>
                  1. Sign on plain white paper with black or blue pen.
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="body2" sx={{ color: "#504E50" }}>
                  2. Signature must be clear, without smudges, and done by you only.
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="body2" sx={{ color: "#504E50" }}>
                  3. Size: 5 KB – 2 MB | Format: JPG/JPEG/PNG | 3.5 × 1.5 cm (140×60 px min, 560×240 px max).
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="body2" sx={{ color: "#504E50" }}>
                  4. Must match your official documents.
                </Typography>
              </Grid>
              <Grid item xs={12} sx={{ marginTop: "0.5rem" }}>
                <span
                  style={{ color: "#504E50", fontSize: "16px", fontWeight: "bold" }}> Note:</span><span style={{ color: "#504E50", fontSize: "14px" }}> If the photo or signature is unclear or does not follow these rules, the application may be rejected.</span>
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
      <Grid
        item
        md={12}
        pb={2}
        pt={2}
        sx={{
          display: "flex",
          justifyContent: "space-between",
          flexDirection: isMobile ? "column" : "row",
        }}
      >
        {/* <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="responsive-dialog-title"
          maxWidth="xs"
        >
          <DialogTitle
            id="responsive-dialog-title"
            sx={{ textAlign: "center", position: "relative" }}
          >
            SAMPLE IMAGE
            <IconButton
              aria-label="close"
              onClick={handleDialogClose}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: "red",
              }}
            >
              <IoCloseOutline />
            </IconButton>
          </DialogTitle>

          <DialogContent
            sx={{
              maxHeight: "400px",
              overflowY: "auto",
              "&::-webkit-scrollbar": {
                display: "none",
              },
              scrollbarWidth: "none",
              msOverflowStyle: "none",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginBottom: "2rem",
              }}
            >
              <img
                src={userphoto}
                alt="Sample"
                style={{
                  width: "135px",
                  height: "148px",
                  borderRadius: "8px",
                }}
              />
            </Box>

            
            <Typography variant="h6" sx={{ color: "#504E50", fontWeight: 500 }}>
              Instructions for Photo:-
            </Typography>
            <Grid container spacing={1} sx={{ marginTop: "3px" }}>
              <Grid item xs={12}>
                <Typography variant="body2" sx={{ color: "#504E50" }}>
                  1. Your photo must be taken within the last six months to
                  reflect your current appearance.
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="body2" sx={{ color: "#504E50" }}>
                  2. Your head should be centered and facing forward, covering
                  about 50-70% of the photo.
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="body2" sx={{ color: "#504E50" }}>
                  3. Both of your ears should be visible, and your eyes should
                  be open and clearly visible.
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="body2" sx={{ color: "#504E50" }}>
                  4. Use a plain white or off-white background, free from
                  shadows or other decorations in your photo.
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="body2" sx={{ color: "#504E50" }}>
                  5. Ensure your photo is well-lit with no shadows on your face
                  or in the background.
                </Typography>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <SubmitButton
              handleSubmit={handleNextClick}
              name={buttonLoader ? "Next" : "Next"}
            />
          </DialogActions>
        </Dialog>
        <Dialog
          open={captureOpen}
          onClose={handleClose}
          aria-labelledby="responsive-dialog-title"
          maxWidth="xs"
        >
          <DialogTitle
            id="responsive-dialog-title"
            sx={{ textAlign: "center", position: "relative" }}
          >
            SAMPLE IMAGE
            <IconButton
              aria-label="close"
              onClick={handleDialogClose}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: "red",
              }}
            >
              <IoCloseOutline />
            </IconButton>
          </DialogTitle>
          <DialogContent
            sx={{
              maxHeight: "400px",
              overflowY: "auto",
              "&::-webkit-scrollbar": {
                display: "none",
              },
              scrollbarWidth: "none",
              msOverflowStyle: "none",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginBottom: "2rem",
              }}
            >
              <img
                src={userphoto}
                alt="Sample"
                style={{
                  width: "135px",
                  height: "148px",
                  borderRadius: "8px",
                }}
              />
            </Box>
            
            <Typography variant="h6" sx={{ color: "#504E50", fontWeight: 500 }}>
              Instructions for Photo:-
            </Typography>
            <Grid container spacing={1} sx={{ marginTop: "3px" }}>
              <Grid item xs={12}>
                <Typography variant="body2" sx={{ color: "#504E50" }}>
                  1. Your photo must be taken within the last six months to
                  reflect your current appearance.
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="body2" sx={{ color: "#504E50" }}>
                  2. Your head should be centered and facing forward, covering
                  about 50-70% of the photo.
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="body2" sx={{ color: "#504E50" }}>
                  3. Both of your ears should be visible, and your eyes should
                  be open and clearly visible.
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="body2" sx={{ color: "#504E50" }}>
                  4. Use a plain white or off-white background, free from
                  shadows or other decorations in your photo.
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="body2" sx={{ color: "#504E50" }}>
                  5. Ensure your photo is well-lit with no shadows on your face
                  or in the background.
                </Typography>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <SubmitButton
              handleSubmit={handleCameraClick}
              name={buttonLoader ? "Next" : "Next"}
            />
          </DialogActions>
        </Dialog>


        <Dialog
          open={signatureOpen}
          onClose={handleClose}
          aria-labelledby="responsive-dialog-title"
          maxWidth="xs"
        >
          <DialogTitle
            id="responsive-dialog-title"
            sx={{ textAlign: "center" }}
          >
            SAMPLE SIGNATURE{" "}
            <IconButton
              aria-label="close"
              onClick={handleDialogClose}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: "red",
              }}
            >
              <IoCloseOutline />
            </IconButton>
          </DialogTitle>
          <DialogContent
            sx={{
              maxHeight: "400px",
              overflowY: "auto",
              "&::-webkit-scrollbar": {
                display: "none",
              },
              scrollbarWidth: "none",
              msOverflowStyle: "none",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginBottom: "2rem",
              }}
            >
              <img
                src={sign}
                alt="Sample"
                style={{
                  width: "181px",
                  height: "88px",
                  borderRadius: "8px",
                  marginTop: "15px",
                }}
              />
              <IoCheckmarkOutline
                style={{
                  width: "23px",
                  height: "23px",
                  right: 14,
                  position: "relative",
                  top: -31,
                  backgroundColor: "#03A600",
                  borderRadius: "50%",
                  color: "#FFFFFF",
                }}
              />
            </Box>

            
            <Typography variant="h6" sx={{ color: "#504E50", fontWeight: 500 }}>
              Instructions for signature:-
            </Typography>
            <Grid container spacing={1} sx={{ marginTop: "3px" }}>
              <Grid item xs={12}>
                <Typography variant="body2" sx={{ color: "#504E50" }}>
                  1. Make sure your signature is clear and legible without any
                  smudges or overlaps.
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="body2" sx={{ color: "#504E50" }}>
                  2. Use a plain white background for your signature to ensure
                  clear visibility.
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="body2" sx={{ color: "#504E50" }}>
                  3. Use a black or dark blue ink pen to sign. Avoid using other
                  colors as they may not scan well.
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="body2" sx={{ color: "#504E50" }}>
                  4.The signature should be done by you personally, not by any
                  other person or digitally generated.
                </Typography>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <SubmitButton
              handleSubmit={handleNextSignatureClick}
              name={buttonLoader ? "Next" : "Next"}
            />
          </DialogActions>
        </Dialog> */}

        <Box sx={{ display: "flex", gap: "8px", pt: 1 }}>
          <BackButton handleBack={handleBack} />
        </Box>

        <Box sx={{ display: "flex", gap: "8px", flexWrap: "wrap", py: 1 }}>


          {/* <SaveButton  name={"Save As Draft"} handleDraft={handleDraft} /> */}
          {/* {!isEditingPage && <SaveButton draftButtonLoader={draftButtonLoader} name={"Save As Draft"} handleDraft={handleDraft} />} */}
          <SubmitButton
            handleSubmit={isEditingPage ? handleEditingFacilityFunc : handleSubmit}
            name={buttonLoader ? "loader" : "Submit"}
          />
        </Box>
      </Grid>
      <Modal open={captureOpen || open} onClose={() => setcaptureOpen(false)} >
        <Grid container style={{ width: "100%", background: "white", height: "100vh", overflow: "auto" }}>
          <span style={{ width: "100%", position: "absolute", display: "flex", justifyContent: "right", marginTop: "20px", paddingRight: "30px", cursor: "pointer" }} onClick={() => {
            setcaptureOpen(false);
            setOpen(false)
            setCaptureShowCard(null)
            setShowCard(null)
          }}> <IoClose size={20} color="#728495" /></span>

          <Grid item sm={12} xs={12} md={12} lg={7} sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
            {loading && (
              <Backdrop
                sx={{
                  backgroundColor: "transparent",
                  color: "#1976d2",
                  zIndex: (theme) => theme.zIndex.drawer + 1,
                }}
                open={loading}
              >
                <CircularProgress color="inherit" size={80} thickness={6} />
              </Backdrop>
            )}
            {captureOpen && !open && (<Box sx={{ flexGrow: 1, display: 'block', padding: "20px" }}>
              <Typography style={{ fontWeight: "bold", fontSize: "18px", color: "#565456" }} mb={2} ml={1}>ADD PHOTO</Typography>

              {captureshowCard == null && (<>
                {cameraPermissionModal ? (
                  <div style={{ width: "95%", height: "76vh" }}>
                    <img src={CameraDenied} alt="verify" style={{
                      width: "95%", height: "76vh",
                      borderRadius: '10px',
                      border: "1px solid #0f4f96"
                    }} />
                  </div>
                ) : (


                  <div style={{ position: "relative", width: "95%", height: "76vh" }}>
                    <Webcam
                      ref={webcamRef}
                      mirrored={true}
                      screenshotFormat="image/jpeg"
                      videoConstraints={{ facingMode: "user" }}
                      style={{
                        width: '95%',
                        height: '76vh',
                        objectFit: 'cover',
                        borderRadius: '10px',
                        border: "1px solid #0f4f96",

                      }}

                    />
                    <canvas
                      ref={canvasRef}
                      style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: "95%", height: "76vh",
                        pointerEvents: "none",
                      }}
                    /></div>
                )}</>)}
              {captureshowCard && (
                <Box sx={{
                  border: '1px solid #0f4f96',
                  py: 4,
                  textAlign: 'center',
                  cursor: 'pointer',
                  borderRadius: 2,
                  width: '95%',
                  height: '76vh',
                  borderWidth: '2px',
                  alignContent: "center"
                }}>
                  <img
                    src={captureshowCard}

                    alt="Selected"
                    style={{
                      width: '100%',
                      height: '100%'
                    }}
                  />
                </Box>
              )}
            </Box>)}
            <Box>
              {
                open && (
                  <>
                    <Box sx={{ flexGrow: 1, display: 'block', padding: "20px", height: "100%", overFlow: 'auto' }}>
                      <Typography style={{ fontWeight: "bold", fontSize: "18px", color: "#565456" }} mb={2} ml={1}>ADD PHOTO</Typography>
                      {showCard && (
                        <Box sx={{
                          border: '1px solid #0f4f96',
                          textAlign: 'center',
                          cursor: 'pointer',
                          borderRadius: 2,
                          width: '95%',
                          height: '76vh',
                          borderWidth: '2px',
                          alignContent: "center"
                        }}>
                          <img
                            src={showCard}
                            alt="Selected"
                            style={{
                              width: '100%',
                              height: '100%',
                              borderRadius: "5px"
                            }}
                          />
                        </Box>
                      )}
                      <input
                        ref={fileInputRef}
                        type="file"
                        name="photofilename"
                        id="photofilename"
                        accept=".jpg, .jpeg, .png"
                        style={{ display: "none" }} // Hide the input
                        onChange={handleImageShow} // Handle file upload
                      />

                      {showCard == null && (
                        <Box
                          sx={{
                            border: '1px dashed #0f4f96',
                            py: 4,
                            textAlign: 'center',
                            cursor: 'pointer',
                            borderRadius: 2,
                            width: '95%',
                            height: '76vh',
                            borderStyle: 'dashed',
                            borderWidth: '2px',
                            alignContent: "center"
                          }}
                          onClick={handleNextClick}
                        >



                          <BsCardImage color="#c6d2df" size={100} />
                          <Typography variant="caption" style={{ fontSize: "22px", color: "#0f4f96", display: "flex", alignItems: "center", justifyContent: "center" }}>
                            Drag and drop a file or  <u style={{ marginLeft: "4px" }}> browse files</u>
                          </Typography>
                        </Box>
                      )}


                    </Box>
                  </>
                )
              }
            </Box>

            <Box sx={{ display: 'flex', alignContent: "center", justifyContent: "space-around" }} mb={2}>
              {!open && captureshowCard && (<Button variant="outlined" style={{ borderRadius: "20px", width: "150px" }} onClick={() => { setCaptureShowCard(null) }}>RECAPTURE</Button>)}
              {mode == "upload" && showCard && (<Button variant="outlined" style={{ borderRadius: "20px", width: "150px" }} onClick={handleNextClick}>REUPLOAD</Button>)}
              {/* <BackButton name={"CANCEL"} /> */}
              {!captureshowCard && captureOpen && !open && (<Button variant="contained" style={{ borderRadius: "20px", width: "150px" }} name={"CAPTURE"} disabled={cameraPermissionModal} onClick={handleImageCaptureShow}>CAPTURE</Button>)}
              {(open || (captureOpen && captureshowCard)) && (<Button variant="contained" style={{ borderRadius: "20px", width: "150px" }} disabled={(confirmationList != "Face detected") ||
                forthErrorlist || disbaleBtnwhenCloserToTheEdge} onClick={mode != "upload" ? handleCaptureSave : handleImageUpload}>SAVE</Button>)}
            </Box>
          </Grid>

          <Grid item sm={12} xs={12} md={12} lg={5} >

            <Box
              sx={{
                ml: {
                  xs: "20px",
                  sm: "20px",
                  md: "20px", // Reset for medium and above if needed
                },
                minHeight: "3rem",
                maxWidth: "541px",
                padding: "1rem",
                backgroundColor: "#F3F6FA",
                marginTop: "60px",
                marginRight: "35px",
                marginBottom: "10px",
                border: "1px solid #0F4F96",
                borderRadius: "20px",
              }}
            >
              {(captureOpen || open) && confirmationList &&
                !firstErrorlist && !secondErrorlist && !thirdErrorlist && !forthErrorlist ? (
                <Box display="flex" alignItems="center">
                  <img
                    src={verify}
                    alt="verify"
                    style={{ height: "20px", width: "20px", marginRight: 8 }}
                  />
                  <Typography variant="body1">{confirmationList}</Typography>
                </Box>
              ) : (
                <Box>
                  {(captureOpen || open) && (
                    <>
                      {open && !forthErrorlist && (
                        <Box display="flex" alignItems="center" mb={1}>
                          <CiWarning size={20} color="orange" style={{ marginRight: 8 }} />
                          <Typography variant="body1">Please Upload A Photo</Typography>
                        </Box>
                      )}
                      {firstErrorlist && (
                        <Box display="flex" alignItems="center" mb={1}>
                          <CiWarning size={20} color="orange" style={{ marginRight: 8 }} />
                          <Typography variant="body1">{firstErrorlist}</Typography>
                        </Box>
                      )}
                      {secondErrorlist && (
                        <Box display="flex" alignItems="center" mb={1}>
                          <CiWarning size={20} color="orange" style={{ marginRight: 8 }} />
                          <Typography variant="body1">{secondErrorlist}</Typography>
                        </Box>
                      )}
                      {thirdErrorlist && (
                        <Box display="flex" alignItems="center">
                          <CiWarning size={20} color="orange" style={{ marginRight: 8 }} />
                          <Typography variant="body1">{thirdErrorlist}</Typography>
                        </Box>
                      )}
                      {forthErrorlist && (
                        <Box display="block" alignItems="center">

                          <Typography variant="body1" display="flex"><CiWarning size={20} color="orange" style={{ marginRight: 8 }} />{forthErrorlist}</Typography>
                          {fifthErrorlist && (<Typography variant="body1" display="flex"><CiWarning size={30} color="orange" style={{ marginRight: 8 }} />{fifthErrorlist}</Typography>
                          )} </Box>
                      )}
                      {cameraPermissionModal && (
                        <Box display="flex" alignItems="center">
                          <CiWarning size={20} color="orange" style={{ marginRight: 8 }} />
                          <Typography variant="body1">Unable To Access Camera.</Typography>
                        </Box>
                      )}
                    </>
                  )}
                  {!captureOpen && !open && (
                    <Box display="flex" alignItems="center">
                      <CiWarning size={20} color="orange" style={{ marginRight: 8 }} />
                      <Typography variant="body1">Please Upload A Photo</Typography>
                    </Box>
                  )}
                </Box>
              )}
            </Box>

            <Box
              sx={{
                ml: {
                  xs: "20px",
                  sm: "20px",
                  md: "20px", // Reset for medium and above if needed
                },
                height: "23rem",
                maxWidth: "541px",
                padding: "1rem",
                backgroundColor: "#F3F6FA",
                marginTop: "30px",
                marginRight: "35px",
                marginBottom: "10px",
                border: "1px solid #0F4F96",
                borderRadius: "20px",
              }}
            >
              <Typography variant="h6" sx={{ color: "#504E50", fontWeight: 500 }}>
                Instructions for Photo:-
              </Typography>
              <Grid container spacing={1} sx={{ marginBottom: "5rem" }}>
                <Grid item xs={12}>
                  <Typography variant="body2" sx={{ color: "#504E50" }}>
                    1. Recent colour photo (last 6 months) with plain & light background.
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="body2" sx={{ color: "#504E50" }}>
                    2. Face straight, looking at camera, covering 50–70%; ears and eyes clearly visible.
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="body2" sx={{ color: "#504E50" }}>
                    3. Size: 15 KB – 5 MB | Format: JPG/JPEG/PNG | 3.5 × 4.5 cm (350×450 px min, 1000×1200 px max).
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="body2" sx={{ color: "#504E50" }}>
                    4. No caps/sunglasses. Religious headgear allowed only if full face is visible.
                  </Typography>
                </Grid>
                {/* <Grid item xs={12}>
                <Typography variant="body2" sx={{ color: "#504E50" }}>
                  5. Ensure your photo is well-lit with no shadows on your face
                  or in the background.
                </Typography>
              </Grid> */}


              </Grid>
              {captureOpen && !open && (<Button variant="outlined" name="UPLOAD" onClick={() => {

                setDisableBtnwhenCloserToTheEdge(false)
                setMode("upload")
                setOpen(true); setShowCard(null)
              }} style={{ borderRadius: "20px", fontWeight: "bold", border: "2px,solid" }} >
                UPLOAD A PHOTO INSTEAD</Button>)}
              <Box>
                {open && (<Button variant="outlined" name="REUPLOAD" onClick={() => {

                  setMode("capture")
                  setCaptureShowCard(null)
                  setOpen(false);
                  setDisableBtnwhenCloserToTheEdge(false)
                }} style={{ borderRadius: "20px", fontWeight: "bold", border: "2px,solid" }} >
                  CAPTURE A PHOTO INSTEAD</Button>)}  </Box>
            </Box>
          </Grid>
        </Grid>
      </Modal>

      <Modal open={signatureOpen} onClose={() => setSignatureOpen(false)}>
        <Grid container style={{ width: "100%", background: "white", height: "100vh", overflow: "auto" }}>
          <span style={{ width: "100%", position: "absolute", display: "flex", justifyContent: "right", marginTop: "20px", paddingRight: "30px", cursor: "pointer" }} onClick={() => {
            setSignatureOpen(false)
            setSignatureShowCard(null)
          }}> <IoClose size={20} color="#728495" /></span>
          <Grid item sm={12} xs={12} md={12} lg={7} sx={{ display: 'flex', flexDirection: 'column' }}>
            {loading && (
              <Backdrop
                sx={{
                  backgroundColor: "transparent",
                  color: "#1976d2",
                  zIndex: (theme) => theme.zIndex.drawer + 1,
                }}
                open={loading}
              >
                <CircularProgress color="inherit" size={80} thickness={6} />
              </Backdrop>
            )}
            <Box>

              <Box sx={{ flexGrow: 1, display: 'block', padding: "20px", height: "100%", overFlow: 'auto' }}>
                <Typography style={{ fontWeight: "bold", fontSize: "18px", color: "#565456" }} mb={2} ml={1}>ADD SIGNATURE</Typography>
                {signatureShowCard && (
                  <Box sx={{
                    border: '1px solid #0f4f96',
                    textAlign: 'center',
                    cursor: 'pointer',
                    borderRadius: 2,
                    width: '95%',
                    height: '76vh',
                    borderWidth: '2px',
                    alignContent: "center"
                  }}>
                    <img
                      src={signatureShowCard}
                      alt="Selected"
                      style={{
                        width: '100%',
                        height: '100%',
                        borderRadius: "5px"
                      }}
                    />
                  </Box>
                )}
                <input
                  ref={fileInputRefSignature}
                  type="file"
                  name="photofilename"
                  id="photofilename"
                  accept=".jpg, .jpeg, .png"
                  style={{ display: "none" }} // Hide the input
                  onChange={handleSignatureShow} // Handle file upload
                />

                {signatureShowCard == null && (
                  <Box
                    sx={{
                      border: '1px dashed #0f4f96',
                      textAlign: 'center',
                      cursor: 'pointer',
                      borderRadius: 2,
                      width: '95%',
                      height: '76vh',
                      borderStyle: 'dashed',
                      borderWidth: '2px',
                      alignContent: "center"
                    }}
                    onClick={handleNextSignatureClick}
                  >



                    <BsCardImage color="#c6d2df" size={100} />
                    <Typography variant="caption" style={{ fontSize: "22px", color: "#0f4f96", display: "flex", alignItems: "center", justifyContent: "center" }}>
                      Drag and drop a file or <u style={{ marginLeft: "4px" }}> browse files</u>
                    </Typography>
                  </Box>
                )}


              </Box>
              <Box sx={{ display: 'flex', alignContent: "center", justifyContent: "space-around" }} mt={-3} mb={2}>

                {signatureShowCard && (<Button variant="outlined" style={{ borderRadius: "20px", width: "150px" }} onClick={handleNextSignatureClick}>REUPLOAD</Button>)}
                {/* <BackButton name={"CANCEL"} /> */}
                <Button style={{ borderRadius: "20px", width: "150px" }} variant="contained" disabled={!signatureShowCard || forthErrorlist} onClick={handleSignatureUpload}>SAVE</Button>
              </Box>

            </Box>
          </Grid>
          <Grid item lg={5} sm={12} xs={12} md={12} >

            <Box
              sx={{
                marginLeft: {
                  xs: "20px",
                  sm: "20px",
                  md: "20px", // Reset for medium and above if needed
                },
                minHeight: "3rem",
                maxWidth: "541px",
                padding: "1rem",
                backgroundColor: "#F3F6FA",
                marginTop: "60px",
                marginRight: "35px",
                marginBottom: "10px",
                border: "1px solid #0F4F96",
                borderRadius: "20px",
              }}
            >
              {signatureShowCard && confirmationList ? (
                <Box display="flex" alignItems="center" mb={1}>
                  <img
                    src={verify}
                    alt="verify"
                    style={{ height: "20px", width: "20px", marginRight: "8px" }}
                  />
                  <Typography variant="body1">Signature detected.</Typography>
                </Box>
              ) : signatureShowCard && forthErrorlist ? (
                <Box display="flex" alignItems="center" mb={1}>
                  <CiWarning size={30} color="orange" style={{ marginRight: 8 }} />
                  <Typography variant="body1">
                    {forthErrorlist || "Signature Not Detected"}
                  </Typography>
                </Box>
              ) : (
                <Box display="flex" alignItems="center" mb={1}>
                  <CiWarning size={20} color="orange" style={{ marginRight: 8 }} />
                  <Typography variant="body1">Please Upload A Photo</Typography>
                </Box>
              )}

            </Box>
            <Box
              sx={{
                marginLeft: {
                  xs: "20px",
                  sm: "20px",
                  md: "20px", // Reset for medium and above if needed
                },
                height: "22rem",
                maxWidth: "541px",
                padding: "1rem",
                backgroundColor: "#F3F6FA",
                marginTop: "30px",
                marginRight: "35px",
                marginBottom: "10px",
                border: "1px solid #0F4F96",
                borderRadius: "20px",
              }}
            >
              <Typography variant="h6" sx={{ color: "#504E50", fontWeight: 500 }}>
                Instructions for Signature:-
              </Typography>
              <Grid container spacing={1} sx={{ marginBottom: "5rem" }}>
                <Grid item xs={12}>
                  <Typography variant="body2" sx={{ color: "#504E50" }}>
                    1. Sign on plain white paper with black or blue pen.
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="body2" sx={{ color: "#504E50" }}>
                    2. Signature must be clear, without smudges, and done by you only.
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="body2" sx={{ color: "#504E50" }}>
                    3. Size: 5 KB – 2 MB | Format: JPG/JPEG/PNG | 3.5 × 1.5 cm (140×60 px min, 560×240 px max).
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="body2" sx={{ color: "#504E50" }}>
                    4. Must match your official documents.
                  </Typography>
                </Grid>


              </Grid>
            </Box>
          </Grid>
        </Grid>

      </Modal>
      {cropPhotoImage && (
        <ImageCrop
          showModal={showModal?.show}
          handleClose={handleClose}
          image={cropPhotoImage}
          onCropDone={onCropDone}
          onCropCancel={onCropCancel}
          mode={mode}
          onCaptureCropCancel={onCaptureCropCancel}
          setForthErrorList={setForthErrorList}
          setFifthErrorList={setFifthErrorList}
          setConfirmationList={setConfirmationList}
          setLoading={setLoading}
          webcamRef={webcamRef}
          setCaptureShowCard={setCaptureShowCard}
          enableCrop={enableCrop}
          setEnableCrop={setEnableCrop}
        />
      )}
      {cropSignatureImage && (
        <ImageCropSignature
          showModal={showModalSignature?.show}
          handleClose={handleClose}
          image={cropSignatureImage}
          onCropDone={onCropDoneSignature}
          onCropCancel={onCropCancelSignature}
          setForthErrorList={setForthErrorList}
          setFifthErrorList={setFifthErrorList}
          setConfirmationList={setConfirmationList}
          setLoading={setLoading}
          webcamRef={webcamRef}
          setCaptureShowCard={setCaptureShowCard}
          setSignatureShowCard={setSignatureShowCard}
          setSignatureValue={setSignatureValue}
        />
      )}
      {/* 
      {showPaymentConfirmationModal ? (
        
      ) : null} */}

      <Modal
        open={showPaymentConfirmationModal}
        onClose={handleClose}
        aria-labelledby="payment-confirmation-title"
        aria-describedby="payment-confirmation-description"
      >
        <Box
          sx={{
            width: 400,
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            p: 4,
            mx: "auto",
            my: "auto",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            textAlign: "center",
          }}
        >
          <Typography
            id="payment-confirmation-title"
            variant="h6"
            sx={{ fontWeight: 600, mb: 2 }}
          >
            Payment Confirmation
          </Typography>

          <Typography
            id="payment-confirmation-description"
            variant="body1"
            sx={{ color: "text.secondary", mb: 3 }}
          >
            Your difference amount that needs to be paid is{" "}
            <strong>₹{editingFacilityAmount}</strong>.
          </Typography>

          <Box sx={{ display: "flex", justifyContent: "space-between", gap: 2 }}>
            <Button
              fullWidth
              variant="outlined"
              color="error"
              onClick={handleClosePaymentConfirmationModal}
            >
              No
            </Button>

            <Button
              fullWidth
              variant="contained"
              color="success"
              onClick={handlePayment}
            >
              Yes, Proceed
            </Button>
          </Box>
        </Box>
      </Modal>


    </Grid>
  );

}
